import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {CSVLink} from "react-csv"
import Loading from "./loading";
import {
  Paper,
  Typography,
  Button,
  FormControl,
  Select,
  Switch,
  TextField,
  MenuItem,
  InputLabel,
  FormGroup,
  FormControlLabel,
  Collapse,
} from "@material-ui/core";
import DateCalc, { identifydest } from "./date";
import { makeStyles } from "@material-ui/core/styles";
import GetRole from "./user";

import { useEffect, useState } from "react";
import {preventDoubleClick} from "./preventDC.js"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  searchconvTripsbyDate,
  updateincentive,
  searchhotTripsbyDate2,
  fetchtripsbypaid,
  fetchtripsbyrefund,
  searchLeadsbyDate,
  fetchtripsbyreceipt,
  fetchConvertedTripsbyTLnDate,
  fetchTeambyName,
  getupsellprofit,
  fetchtripsbysupplierpending,
  fetchtripsbyaccount,
  searchConvTripsbyStartDate,
  fetchquotefromlist,
  fetchstatushistory,
  searchclosedTripsbyDate,
  searchclosedDABTripsbyDate,
  searchconvTripsbyDatenOwner,
  searchpersonalConvTripsbyStartDate,
  fetchtripsbysupplierrefund,
  newsearchQEbyDate2,
  analyzedocs, getanalyzedocsresult,
  searchcreatedTripsbyDate,
  fetchquotefromlist2, freezeprofit, fetchtripsbypaidinternalteam, fetchtcsquery, fetchtripsbychangelog
} from "../api/customerapi";
import {getmonth, getmonth2, removeDuplicates, getmanager, getSumByKey2, getconvdate, getprofit, gettcs, DateCalc2, gettaxes, getstate, getquality, newgetqualitylead, getnextpaymentdate, total, spundertl, creditnotetotal, hotelupsellprofittotal, refundtotal, onlyreceivedtotal, getcomment, getflightprofit, profitwithoutupsell, receivedwocreditnrefund, checkserviceduration, removeDuplicatesbysortingkey} from "./date.js"


const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(20),
    height: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: 10,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),
    width: theme.spacing(25),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: "left",
  },
  formgroup: {
    justifyContent: "center",   
},
}));

const Dashboard = () => {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const width = window.innerWidth - 200;
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const columns = [
    {
      field: "name",
      headerName: " Name",
      width: width / 12,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "revenue",
      headerName: "Revenue",
      width: (width / 12),
    },
    {
      field: "targets",
      headerName: "Target",
      width: width / 12,
    },
    {
      field: "achieved",
      headerName: "Achieved",
      width: (width / 12),
    },
   {
      field: "num_trips",
      headerName: "Trips",
      width: (width / 12)*0.75,
    },
    {
      field: "conv_req",
      headerName: "Conv Target",
      width: (width / 12)*0.75,
    },
    {
      field: "hot_req",
      headerName: "Hot Required",
      width: (width / 12)*0.75,
    },
    {
      field: "num_hot_till_now",
      headerName: "Target Hot",
      width: (width / 12)*0.75,
    },
    {
      field: "num_hot",
      headerName: "Hot Made",
      width: (width / 12)*0.75,
    },
    {
      field: "num_qe_req",
      headerName: "QE Req",
      width: (width / 12)*0.75,
    },
    
    {
      field: "num_qe",
      headerName: "QE Made",
      width: (width / 12)*0.75,
    },
    {
      field: "number_bookings",
      headerName: "Conversions",
      width: (width / 12)*0.75,
    },
    {
      field: "h2c",
      headerName: "H2C",
      width: (width / 12)*0.75,
    },
    {
      field: "qe2h",
      headerName: "QE2H",
      width: (width / 12)*0.75,
    },
   
       {
      field: "ppb",
      headerName: "Profit/Conv",
      width: (width / 12)*0.75,
    },
    {
      field: "profit_percentage",
      headerName: "Profit %",
      width: (width / 12) * 1,
    },
   
    {
      field: "incentives",
      headerName: "Max Incentives",
      width: width / 12,
    },
    {
      field: "category",
      headerName: "SP Category",
      width: width / 12,
    },
     {
      field: "tl",
      headerName: "TL",
      width: width / 12,
    },
    
  ];
  const columns2 = [
    {
      field: "trip_id",
      headerName: "Trip_Id",
      width: (width / 12) * 1,
    },
    {
      field: "name",
      headerName: " Customer Name",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: 'dest',
      headerName: 'Destination',
      width: width/12*1.5,

    },
    {
      field: 'product_check',
      headerName: 'Product',
      width: width/12,

    },
    {
      field: 'notax',
      headerName: 'No Tax',
      width: width/12,
    },
    {
      field: 'notcs',
      headerName: 'No TCS',
      width: width/12,
    },
    {
      field: 'of',
      headerName: 'Only Flight',
      width: width/12,
    },
    
   
    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },
    {
      field: "tcs_mail",
      headerName: "TCS Mail",
      width: (width / 12) * 1,
    },
    {
      field: "count",
      headerName: "Status",
      width: (width / 12) * 1,
    },
     {
      field: "supplier",
      headerName: "Supplier",
      width: (width / 12) * 1,
    },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },

    
  ];
  const columns2b = [
    {
      field: "trip_id",
      headerName: "Trip_Id",
      width: (width / 12) * 1,
    },
    {
      field: "cust_name",
      headerName: " Customer Name",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
  {
      field: "account",
      headerName: "Account",
      width: (width / 12) * 1,
    },
    
    
   
    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },
   
     
    

    
  ];
  const columns2c = [
    {
      field: "date",
      headerName: "Date",
      width: (width / 12) * 1,
    },
    {
      field: "count",
      headerName: " Count",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    
  ];
  const columns3 = [
    {
      field: "trip_id",
      headerName: "Trip_Id",
      width: (width / 12) * 1,
    },
    {
      field: "name",
      headerName: " Name",
      width: (width / 12) * 2,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: width/12,

    },
    // {
    //   field: 'date',
    //   headerName: 'Date',
    //   width: width/12,
    // },
    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1.5,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: (width / 12) * 1,
    },
    {
      field: "supplier_name",
      headerName: "Supplier",
      width: (width / 12) * 1,
    },

    {
      field: 'no_tax',
      headerName: 'SC',
      width: width/12,
    },
    {
      field: 'only_flight',
      headerName: 'OF',
      width: width/12,
    },
    {
      field: 'no_tcs',
      headerName: 'PD',
      width: width/12,
    },
    {
      field: 'payment_date',
      headerName: 'Date',
      width: width/12,
    },
  ];

  const columns4 = [
    {
      field: "trip_id",
      headerName: "Trip_Id",
      width: (width / 12) * 0.5,
    },
    {
      field: "name",
      headerName: " Customer Name",
      width: (width / 12) * 1.5,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "trip_owner",
      headerName: "Trip Owner",
      width: width / 12,
    },
    {
      field: "revenue",
      headerName: "Revenue",
      width: (width / 12) * 1,
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) * 1,
    },
    {
      field: "received",
      headerName: "Received",
      width: (width / 12) * 1,
    },
    {
      field: "land_profit",
      headerName: "Land Profit %",
      width: (width / 12) * 1,
    },

    {
      field: "trip_start_date",
      headerName: "Trip Start Date",
      width: (width / 12) * 1,
    },
    {
      field: "duration",
      headerName: "Duration",
      width: width / 12,
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: width / 12,
    },
    
    {
      field: "channel",
      headerName: "Channel",
      width: width / 12,
    },
    {
      field: "dest",
      headerName: "Destination",
      width: width / 12,
    },
    {
      field: "rev_pp",
      headerName: "Revenue PP",
      width: (width / 12) * 1,
    },
    {
      field: "flight_pp",
      headerName: "Flight PP",
      width: (width / 12) * 1,
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12) * 1,
    },
    {
      field: "special",
      headerName: "Special?",
      width: width / 12,
    },
    {
      field: "only_flight",
      headerName: "Only Flight?",
      width: width / 12,
    },
    {
      field: "notcs",
      headerName: " No TCS?",
      width: width / 12,
    },
    {
      field: "onhold",
      headerName: " On Hold?",
      width: width / 12,
    },
    {
      field: "state",
      headerName: "State",
      width: width / 12,
    },
    {
      field: "tcs_mail",
      headerName: "TCS Mail",
      width: width / 12,
    },
    {
      field: "ops_status",
      headerName: "Ops Status",
      width: width / 12,
    },
    {
      field: "ops_owner",
      headerName: "Ops",
      width: width / 12,
    },
    {
      field: "team_leader",
      headerName: "TL",
      width: width / 12,
    },
     {
      field: "manager",
      headerName: "Manager",
      width: width / 12,
    },
    {
      field: 'conv_quote',
      headerName: 'Converted Quote',
      width: width/12,
    },
    {
      field: 'pax',
      headerName: 'Pax',
      width: width/12,
    },
    {
      field: 'cost',
      headerName: 'Cost',
      width: width/12,
    },
    {
      field: 'gst',
      headerName: 'GST',
      width: width/12,
    },
    {
      field: 'tcs',
      headerName: 'TCS',
      width: width/12,
    },
    {
      field: "inc_profit",
      headerName: "Inc. Profit",
      width: (width / 12) * 1,
    },
    
    {
      field: "land_revenue",
      headerName: "Land Revenue",
      width: (width / 12) * 1,
    },
     {
      field: "next_payment_date",
      headerName: "Next Payment Date",
      width: (width / 12) * 1,
    },
      {
      field: "urgent",
      headerName: "Urgent",
      width: (width / 12) * 1,
    },
     {
      field: "quality",
      headerName: "Quality",
      width: (width / 12) * 1,
    },
     {
      field: "lead_id",
      headerName: "Lead Id",
      width: (width / 12) * 1,
    },
     {
      field: "incentive_paid",
      headerName: "Incentive Paid",
      width: (width / 12) * 1,
    },
     {
      field: "tl_incentive",
      headerName: "TL Incentive",
      width: (width / 12) * 1,
    },
     {
      field: "sp_incentive",
      headerName: "SP Incentive",
      width: (width / 12) * 1,
    },
    {
      field: "upsell_profit",
      headerName: "Upsell Profit",
      width: (width / 12) * 1,
    },
     {
      field: "first_installment_amount",
      headerName: "First Amount",
      width: (width / 12) * 1,
    },
     {
      field: "total_received",
      headerName: "Total Received",
      width: (width / 12) * 1,
    },
     {
      field: "b2s_date",
      headerName: "Status Date",
      width: (width / 12) * 2,
    },
     {
      field: "last_update_gap",
      headerName: "Gap",
      width: (width / 12) * 1,
    },
     {
      field: "briefing_call",
      headerName: "Briefing Call",
      width: (width / 12) * 1,
    },
     {
      field: "month_end_profit",
      headerName: "Month End Profit",
      width: (width / 12) * 1,
    },
     {
      field: "difference",
      headerName: "Profit Gap",
      width: (width / 12) * 1,
    },
    {
      field: "manual_fr",
      headerName: "FR Suucess",
      width: (width / 12) * 1,
    },
    {
      field: "model_beta",
      headerName: "Model",
      width: (width / 12) * 1,
    },
  ];
  const columns5 = [
    {
      field: "name",
      headerName: " Destination",
      width: (width / 12),
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "revenue",
      headerName: "Revenue",
      width: (width / 12),
    },
    {
      field: "land_revenue",
      headerName: "Land Revenue",
      width: (width / 12),
    },
    {
      field: "achieved",
      headerName: "Achieved",
      width: (width / 12),
    },

    {
      field: "profit_percentage",
      headerName: "Profit %",
      width: (width / 12),
    },
    {
      field: "number_bookings",
      headerName: "Conversions",
      width: width / 12,
    },
    {
      field: "ops_cost",
      headerName: "Ops Cost",
      width: (width / 12),
    },
    {
      field: "ops_cm",
      headerName: "Ops CM",
      width: (width / 12),
    },

    {
      field: "cost",
      headerName: "MC",
      width: (width / 12),
    },
    {
      field: "cm",
      headerName: "CM",
      width: (width / 12),
    },
    {
      field: "cm_lead",
      headerName: "CM/Lead",
      width: (width / 12),
    },
    {
      field: "cm_perc",
      headerName: "CM %",
      width: (width / 12),
    },
  ];
  const columns6 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12) ,
   
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12) ,
   
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) ,
   
    },
    {
      field: "trip_status",
      headerName: "Status",
      width: (width / 12) ,
   
    },
    {
      field: "upsell_value",
      headerName: "Upsell Value",
      width: (width / 12) ,
   
    },
    {
      field: "upsell_profit",
      headerName: "Upsell Profit",
      width: (width / 12) ,
   
    },
    {
      field: "tl_incentive",
      headerName: "TL Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "sp_incentive",
      headerName: "SP Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "incentive_paid",
      headerName: "Incentive Paid?",
      width: (width / 12) ,
   
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) ,
   
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "tcs",
      headerName: "TCS",
      width: (width / 12) ,
   
    },
  ];

  const columns7 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12) ,
   
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12) ,
   
    },
    {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) ,
   
    },
    {
      field: "trip_status",
      headerName: "Status",
      width: (width / 12) ,
   
    },
    {
      field: "incentive_paid",
      headerName: "Incentive Paid?",
      width: (width / 12) ,
   
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12) ,
   
    },
    {
      field: "spincentivesum",
      headerName: "SP Sum",
      width: (width / 12) ,
   
    },
    {
      field: "sp_incentive_slab",
      headerName: "SP Slab",
      width: (width / 12) ,
   
    },
     {
      field: "tlincentivesum",
      headerName: "TL Sum",
      width: (width / 12) ,
   
    },
    {
      field: "tl_incentive_slab",
      headerName: "TL Slab",
      width: (width / 12) ,
   
    },
    {
      field: "upsell_incentive_slab",
      headerName: "Upsell Slab",
      width: (width / 12) ,
   
    },
    {
      field: "upsell_incentive",
      headerName: "Upsell Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "tl_incentive",
      headerName: "TL Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "manager_incentive",
      headerName: "Manager Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "sp_incentive",
      headerName: "SP Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "ops_name",
      headerName: "Ops",
      width: (width / 12) ,
   
    },
     {
      field: "biometric_id",
      headerName: "Bio",
      width: (width / 12) ,
   
    },
    {
      field: "cx_incentive",
      headerName: "CX Incentive",
      width: (width / 12) ,
   
    },
    
    {
      field: "tl",
      headerName: "TL",
      width: (width / 12) ,
   
    },
    {
      field: "manager",
      headerName: "Manager",
      width: (width / 12) ,
   
    },
    {
      field: "revenue",
      headerName: "Revenue",
      width: (width / 12) ,
   
    },
   
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12) ,
   
    },
    {
      field: "land_profit",
      headerName: "Land Profit",
      width: (width / 12) ,
   
    },
    {
      field: "sales_incentive_new",
      headerName: "New SP Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "ops_incentive_new",
      headerName: "New Ops Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "flight_incentive_new",
      headerName: "New Flight Incentive",
      width: (width / 12) ,
   
    },
    {
      field: "addreward",
      headerName: "Cess",
      width: (width / 12) ,
   
    },
    {
      field: "closed_date",
      headerName: "Closed At",
      width: (width / 12) ,
   
    },
  ];

   const columns18 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "trip_owner",
      headerName: "SP",
      width: (width / 12) ,
   
    },
    {
      field: "ops_owner",
      headerName: "Ops",
      width: (width / 12) ,
   
    },
    
    {
      field: "entity",
      headerName: "Entity",
      width: (width / 12) ,
   
    },
    {
      field: "changed_by",
      headerName: "Changed By",
      width: (width / 12) ,
   
    },
    {
      field: "old_value",
      headerName: "Old Value",
      width: (width / 12) ,
   
    },
   
    {
      field: "new_value",
      headerName: "New Value",
      width: (width / 12) ,
   
    },
    {
      field: "old_profit",
      headerName: "Old Profit",
      width: (width / 12) ,
   
    },
     {
      field: "new_profit",
      headerName: "New Profit",
      width: (width / 12) ,
   
    },
    {
      field: "gap",
      headerName: "Gap",
      width: (width / 12) ,
   
    },
  ];

  const columns11 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12) ,
   
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12) ,
   
    },
    
    {
      field: "pan",
      headerName: "PAN",
      width: (width / 12) ,
   
    },
    {
      field: "invoice_name",
      headerName: "Invoice",
      width: (width / 12) ,
   
    },
   
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
  ];

    const columns12 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12) ,
   
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12) ,
   
    },  
    {
      field: "ops_owner",
      headerName: "Ops Owner",
      width: (width / 12) ,
   
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
     {
      field: "conv_date",
      headerName: "Conv Date",
      width: (width / 12) ,
   
    },
     {
      field: "old_profit",
      headerName: "Sales Profit",
      width: (width / 12) ,
   
    },
     {
      field: "current_profit",
      headerName: "Ops Profit",
      width: (width / 12) ,
   
    },
     {
      field: "diff",
      headerName: "Difference",
      width: (width / 12) ,
   
    },
    {
      field: "old_profit_perc",
      headerName: "Sales Profit %",
      width: (width / 12) ,
   
    },
     {
      field: "new_profit_perc",
      headerName: "Ops Profit %",
      width: (width / 12) ,
   
    },
     {
      field: "diff_profit_perc",
      headerName: "Diff in %",
      width: (width / 12) ,
   
    },
     {
      field: "quote_profit",
      headerName: "Quote Profit",
      width: (width / 12) ,
   
    },
    {
      field: "flight_profit",
      headerName: "Flight Profit",
      width: (width / 12) ,
   
    },
    {
      field: "diff_without_flight",
      headerName: "Diff w/o flight",
      width: (width / 12) ,
   
    },
    {
      field: "ops_note",
      headerName: "Ops Note",
      width: (width / 12)*4 ,
   
    },
  ];

  const columns16 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12) ,
   
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
    {
      field: "duration",
      headerName: "Duration",
      width: (width / 12) ,
   
    },
    {
      field: "land_sp",
      headerName: "Land SP",
      width: (width / 12) ,
   
    },
    {
      field: "trip_status",
      headerName: "Trip Status",
      width: (width / 12) ,
   
    },
    {
      field: "tcs",
      headerName: "TCS",
      width: (width / 12) ,
   
    },
    {
      field: "pan_cust",
      headerName: "PAN Cust",
      width: (width / 12)*3,
   
    },
    {
      field: "pan_name",
      headerName: "PAN Name",
      width: (width / 12)*3,
   
    },
    {
      field: "pan",
      headerName: "PAN",
      width: (width / 12)*3,
   
    },
    
  ];

   const columns17 = [
    {
      field: "trip_id",
      headerName: "Trip ID",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "name",
      headerName: "Name",
      width: (width / 12)*3 ,
   
    },
    {
      field: "dest",
      headerName: "Destination",
      width: (width / 12),
   
    },
    {
      field: "date",
      headerName: "Date",
      width: (width / 12) *2,
   
    },
    {
      field: "tour_name",
      headerName: "Tour Name",
      width: (width / 12)*3,
   
    },
   
    
  ];

  const columns15 = [
    {
      field: "category",
      headerName: "Category",
      width: (width / 12)*3 ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "sales",
      headerName: "Sales",
      width: (width / 12) ,
   
    },
    {
      field: "profit",
      headerName: "Profit",
      width: (width / 12),
   
    },
    {
      field: "valid_trips",
      headerName: "Eligible",
      width: (width / 12) ,
   
    },
    
    {
      field: "pitch",
      headerName: "Pitched",
      width: (width / 12) ,
   
    },
    {
      field: "pitch_share",
      headerName: "Pitch %",
      width: (width / 12) ,
   
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12) ,
   
    },
    {
      field: "share",
      headerName: "% share (total)",
      width: (width / 12),
   
    },
     {
      field: "total_share",
      headerName: "% share (pitch)",
      width: (width / 12),
   
    },
   {
      field: "profit_perc",
      headerName: "Profit %",
      width: (width / 12),
   
    },
    
  ];

  const columns14 = [
    {
      field: "days",
      headerName: "Days",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12) ,
   
    },
    
    
  ];

  const columns4b = [
    {
      field: "category",
      headerName: "Category",
      width: (width / 12)*4,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
    {
      field: "count",
      headerName: "Count",
      width: (width / 12) ,
   
    },
    {
      field: "count_perc",
      headerName: "Count %",
      width: (width / 12) ,
   
    },
    
    
  ];
  
  const columns19 = [
    {
      field: "trip_id",
      headerName: "Trip Id",
      width: (width / 12) ,
      cellClassName: "gridcell",
      //align:"center",
      //headerAlign:"center"
    },
     {
      field: "name",
      headerName: "Customer",
      width: (width / 12) ,
   
    },
    {
      field: "trip_owner",
      headerName: "Owner",
      width: (width / 12) ,
   
    },
     {
      field: "trip_start_date",
      headerName: "Start Date",
      width: (width / 12) ,
   
    },
    {
      field: "destination",
      headerName: "Destination",
      width: (width / 12) ,
   
    },
    {
      field: "total",
      headerName: "Revenue",
      width: (width / 12) ,
   
    },
    {
      field: "received",
      headerName: "Received",
      width: (width / 12) ,
   
    },
    {
      field: "credit_note",
      headerName: "Credit Note",
      width: (width / 12) ,
   
    },
     {
      field: "refund",
      headerName: "Refund",
      width: (width / 12) ,
   
    },
    {
      field: "profit",
      headerName: "Current profit",
      width: (width / 12) ,
   
    },
    {
      field: "sales_profit",
      headerName: "Sales profit",
      width: (width / 12) ,
   
    },
    
    
  ];

   const headers19=[
    {label:"Trip Id", key:"trip_id"},
    {label:"Name", key:"name"},
    {label:"Owner", key:"trip_owner"},
    {label:"Start Date", key:"trip_start_date"},
    
    {label:"Destination", key:"destination"},
    {label:"Revenue", key:"total"},
    {label:"Received", key:"received"},
    {label:"Profit", key:"profit"},
    {label:"Credit Note", key:"credit_note"},
    {label:"Refund", key:"refund"},
    {label:"Sales Profit", key:"sales_profit"},
    
]


  const headers8=[
    {label:"Trip Id", key:"trip_id"},
    {label:"Name", key:"name"},
    {label:"Owner", key:"trip_owner"},
    {label:"Incentive Paid", key:"incentive_paid"},
    {label:"Conv Date", key:"conv_date"},
    {label:"Start Date", key:"trip_start_date"},
    {label:"TL", key:"tl"},
    {label:"Manager", key:"manager"},
    {label:"Ops Name", key:"ops_name"},
    {label:"Biometric Id", key:"biometric_id"},
    {label:"Upsell Incentive Slab", key:"upsell_incentive_slab"},
    {label:"Upsell Incentive", key:"upsell_incentive"},
    {label:"Upsell Profit", key:"upsell_profit"},
    {label:"TL Sum", key:"tlincentivesum"},
    {label:"SP Sum", key:"spincentivesum"},
    {label:"CX Incentive", key:"ops_incentive"},
    {label:"SP Incentive", key:"sp_incentive"},
    {label:"SP Incentive Slab", key:"sp_incentive_slab"},
    {label:"TL Incentive Slab", key:"tl_incentive_slab"},
    {label:"Profit", key:"profit"},
    {label:"Destination", key:"dest"},
    {label:"Revenue", key:"revenue"},
    {label:"Error", key:"error"},
    {label:"Flight Profit", key:"flight_profit"},
    {label:"Land Profit", key:"land_profit"},
    {label:"Ops Incentive", key:"ops_incentive_new"},
    {label:"Sales Incentive", key:"sales_incentive_new"},
    {label:"Flight Incentive", key:"flight_incentive_new"},
    {label:"TL Incentive", key:"tl_incentive"},
    {label:"Manager Incentive", key:"manager_incentive"},
    {label:"Cess", key:"addreward"},
    {label:"Trip Status", key:"trip_status"},
    {label:"Closed Date", key:"closed_date"},
]

  const headers6=[
    {label:"Trip Id", key:"trip_id"},
    {label:"Name", key:"name"},
    {label:"Owner", key:"trip_owner"},
    {label:"Status", key:"trip_status"},
    {label:"Conv Date", key:"conv_date"},
    {label:"Start Date", key:"trip_start_date"},
    {label:"Upsell Value", key:"upsell_value"},
    {label:"Upsell Profit", key:"upsell_profit"},
    {label:"TL Incentive", key:"tl_incentive"},
    {label:"SP incentive", key:"sp_incentive"},
    {label:"Profit", key:"profit"},
    {label:"TCS", key:"tcs"},
    {label:"Destination", key:"dest"},
]

const headers=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Owner", key:"trip_owner"},
  {label:"Revenue", key:"revenue"},
  {label:"Conv Date", key:"conv_date"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Profit", key:"profit"},
  {label:"Received", key:"received"},
  {label:"Dest", key:"dest"},
  {label:"Channel", key:"channel"},
  {label:"Duration", key:"duration"},
  {label:"State", key:"state"},
  {label:"Special?", key:"special"},
  {label:"Only Flight?", key:"only_flight"},
  {label:"NO TCS?", key:"notcs"},
  {label:"On Hold?", key:"onhold"},
  {label:"TL", key:"team_leader"},
  {label:"Manager", key:"manager"},
  {label:"TCS Mail", key:"tcs_mail"},
  {label:"Ops Status", key:"ops_status"},
  {label:"Ops Owner", key:"ops_owner"},
  {label:"Conv Quote", key:"conv_quote"},
  {label:"Land Revenue", key:"land_revenue"},
  {label:"Pax", key:"pax"},
  {label:"GST", key:"gst"},
  {label:"TCS", key:"tcs"},
  {label:"Cost", key:"cost"},
  {label:"Flight Profit", key:"flight_profit"},
  {label:"Ops Profit", key:"inc_profit"},
  {label:"Next Payment Date", key:"next_payment_date"},
  {label:"Quality", key:"quality"},
  {label:"Lead Id", key:"lead_id"},
  {label:"TL Incentive", key:"tl_incentive"},
  {label:"SP Incentive", key:"sp_incentive"},
  {label:"Inc. Paid?", key:"incentive_paid"},
  {label:"Upsell Profit", key:"upsell_profit"},
  {label:"First Installment Amount", key:"first_installment_amount"},
  {label:"Total Received", key:"total_received"},
  {label:"Status Date", key:"b2s_date"},
  {label:"Gap", key:"last_update_gap"},
  {label:"Briefing Call", key:"briefing_call"},
  {label:"Month End Profit", key:"month_end_profit"},
  {label:"Difference", key:"difference"},
  {label:"FR Success", key:"manual_fr"},
  {label:"Model", key:"model"},
]

const headers3=[
  
  {label:"Name", key:"name"},
  {label:"Revenue", key:"revenue"},
  {label:"Achieved", key:"achieved"},
  {label:"Profit/Conv", key:"ppb"},
  {label:"Trips", key:"trips"},
  {label:"Conv Required", key:"conv_req"},
  {label:"Hot Required", key:"hot_req"},
  {label:"Hot Made", key:"num_hot"},
  {label:"QE Made", key:"num_qe"},
  {label:"H2C", key:"h2c"},
  {label:"QE2H", key:"qe2h"},
  {label:"Profit %", key:"profit_percentage"},
  {label:"# Bookings", key:"number_bookings"},
  {label:"Target", key:"targets"},
  
]

const headers2=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Owner", key:"trip_owner"},
  {label:"Amount", key:"amount"},
  {label:"Destination", key:"dest"},
  {label:"Count", key:"count"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"No tax", key:"notax"},
  {label:"No TCS", key:"notcs"},
  {label:"Only Flight", key:"of"},
  {label:"TCS Mail", key:"tcs_mail"},
  {label:"Supplier", key:"supplier"},
  
]

const headers2b=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"cust_name"},
  {label:"Amount", key:"amount"},
  {label:"Account", key:"account"},

]

const headers4=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Owner", key:"trip_owner"},
  {label:"Amount", key:"amount"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Amount", key:"amount"},
  {label:"Supplier", key:"supplier_name"},
    {label:"SC", key:"no_tax"},
      {label:"OF", key:"only_flight"},
        {label:"PD", key:"no_tcs"},
 { label:"Status", key:"status"},
]

const headers11=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Owner", key:"trip_owner"},
  {label:"Destination", key:"dest"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Invoice Name", key:"invoice_name"},
  {label:"PAN", key:"pan"},
 
]

const headers10=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Owner", key:"trip_owner"},
  {label:"Ops", key:"ops_owner"},
  {label:"Destination", key:"dest"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Conv Date", key:"conv_date"},
  {label:"Sales Profit", key:"old_profit"},
  {label:"Current Profit", key:"current_profit"},
  {label:"Diff", key:"diff"},
  {label:"Sales Profit %", key:"old_profit_perc"},
  {label:"Ops Profit %", key:"new_profit_perc"},
  {label:"Diff in %", key:"diff_profit_perc"},
  {label:"Quote Profit", key:"quote_profit"},
  {label:"Flight Profit", key:"flight_profit"},
  {label:"Diff W/O Flight", key:"diff_without_flight"},
  {label:"Ops Note", key:"ops_note"},
]

const headers16=[
  {label:"Trip Id", key:"trip_id"},
  {label:"Name", key:"name"},
  {label:"Destination", key:"destination"},
  {label:"Start Date", key:"trip_start_date"},
  {label:"Status", key:"trip_status"},
  {label:"Duration", key:"duration"},
  {label:"Land SP", key:"land_sp"},
  {label:"PAN Cust", key:"pan_cust"},
  {label:"PAN Name", key:"pan_name"},
  {label:"PAN", key:"pan"},
  {label:"TCS", key:"tcs"},
]

const headers15=[
  {label:"Category", key:"category"},
  {label:"Sales", key:"sales"},
  {label:"Profit", key:"profit"},
   {label:"Eligible", key:"valid_trips"},
    {label:"Pitched", key:"pitch"},
  {label:"Pitch %", key:"pitch_share"},
  {label:"Count", key:"count"},
   {label:"Total Share", key:"share"},
      {label:"Pitch Share", key:"total_share"},
 { label:"Profit %", key:"profit_perc"},
]

const headers18=[
  {label:"Trip Id", key:"trip_id"},
  {label:"SP", key:"trip_owner"},
  {label:"Ops", key:"ops_owner"},
   {label:"Entity", key:"entity"},
   {label:"Changed By", key:"changed_by"},
    {label:"Old Value", key:"old_value"},
  {label:"New Value", key:"new_value"},
  {label:"Old Profit", key:"old_profit"},
   {label:"New Profit", key:"new_profit"},

]

var specialincentivelist=[228712, 231509, 232140, 229063, 232607, 232544, 233089, 233597, 232323, 234350, 233587, 234770, 233155, 233698, 235585]

  const [listtripData, setlisttripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [hottripData, sethottripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [createdtripData, setcreatedtripData] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData2, setlisttripData2] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData3, setlisttripData3] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "Kashmir",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData4, setlisttripData4] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData6, setlisttripData6] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData7, setlisttripData7] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData8, setlisttripData8] = useState([
    {
      trip_id: "",
    trip_owner: "",
    tl: "",
    name: "",
    dest:"",
    trip_start_date: "",
    conv_date:"",
    sp_incentive_slab:"",
    ops_name:"",
    ops_incentive:"",
    id:1,
    incentive_paid:"",
    profit:"",
    sp_incentive:""
    },
  ]);
  const [listtripData9, setlisttripData9] = useState([
    {
      trip_id: "",
    trip_owner: "",
    tl: "",
    name: "",
    dest:"",
    trip_start_date: "",
    conv_date:"",
    sp_incentive_slab:"",
    ops_name:"",
    ops_incentive:"",
    id:1,
    incentive_paid:"",
    profit:"",
    sp_incentive:""
    },
  ]);
  const [listtripData10, setlisttripData10] = useState([
    {
      trip_id: "",
    trip_owner: "",
    tl: "",
    name: "",
    dest:"",
    trip_start_date: "",
    conv_date:"",
    sp_incentive_slab:"",
    ops_name:"",
    ops_incentive:"",
    id:1,
    incentive_paid:"",
    profit:"",
    sp_incentive:""
    },
  ]);
   const [listtripData11, setlisttripData11] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData16, setlisttripData16] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData17, setlisttripData17] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData18, setlisttripData18] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData19, setlisttripData19] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      status_history: [],
      trip_owner: "",
      follow_up: [
        {
          status: "Open",
          notes: "",
        },
      ],
    },
  ]);
  const [listtripData28, setlisttripData28] = useState([
    {
      start_date_undecided: "No",

      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "New",
      booking: {ops_assigned:""},
      trip_owner: "",
      changelog: 
        {
          entity: "Open",
          old_value: "",
          new_value:"",
          old_profit:"",
          new_profit:"",
          changed_by:"",
        },
      
    },
  ]);
  const [createdleadData, setcreatedleadData] = useState([]);
  const [qeData, setqeData] = useState([]);
  const [tl, settl] = useState([]);
  const [searchData, setsearchData] = useState({});
  const [searchbypending, setsearchbypending] = useState(false);
  const [searchbyinternalteam, setsearchbyinternalteam] = useState(false);
  const [searchData4, setsearchData4] = useState({});
  const [searchData5, setsearchData5] = useState({});
  const [emp, setemp] = useState([]);
  const [emp2, setemp2] = useState([]);
  const [emp3, setemp3] = useState([]);
  const [emptl, setemptl] = useState([]);
  const [upsellcat, setupsellcat] = useState([]);
  const [searchbyid, setsearchbyid] = useState(false);
  const [searchbyb2s, setsearchbyb2s] = useState(false);
  const [finalinstallmentflag, setfinalinstallmentflag] = useState(false);
  const [working, setworking]=useState(false);
  const [filterData, setfilterData]=useState({});
  const [searchData2, setsearchData2] = useState({});
  const [searchData3, setsearchData3] = useState({});
  const [searchData6, setsearchData6] = useState({});
  const [searchData7, setsearchData7] = useState({});
  const [searchData8, setsearchData8] = useState({});
  const [searchData9, setsearchData9] = useState({});
  const [searchData10, setsearchData10] = useState({});
  const [searchData15, setsearchData15] = useState({});
  const [searchData16, setsearchData16] = useState({});
  const [searchData17, setsearchData17] = useState({});
  const [datalistdisplay1, setdatalistdisplay1] = useState([]);
  const [datalistdisplay16, setdatalistdisplay16] = useState([]);
  const [dest, setdest] = useState([]);
  const [profitloss, setprofitloss] = useState(0);
  const [quotelistdata, setquotelistdata] = useState(false);
  const [selection, setselection] = useState([]);
  const [expanded1, setexpanded1] = useState(false);
  const [expanded2, setexpanded2] = useState(false);
  const [expanded3, setexpanded3] = useState(false);
  const [expanded4, setexpanded4] = useState(false);
  const [expanded5, setexpanded5] = useState(false);
  const [expanded6, setexpanded6] = useState(false);
  const [expanded7, setexpanded7] = useState(false);
  const [expanded8, setexpanded8] = useState(false);
  const [expanded9, setexpanded9] = useState(false);
  const [expanded10, setexpanded10] = useState(false);
  const [expanded11, setexpanded11] = useState(false);
  const [expanded12, setexpanded12] = useState(false);
  const [expanded19, setexpanded19] = useState(false);
  const [expanded21, setexpanded21] = useState(false);
  const [expanded22, setexpanded22] = useState(false);
  var tl1 = "Sidharth";
  var tl2 = "Hitesh";
  var tl3 = "Yadvinder";
  var tl4 = "Tulsi";
  var tl5 = "Tarun";
  var tl6 = "NitinK";
  var tl7 = "Manish";
  var tl8 = "Qausain";
  const getTripsbyTL = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
   try{
    if (start_date && end_date) {
      const data = await fetchConvertedTripsbyTLnDate(
        tl1,
        start_date,
        end_date
      );
      //console.log(data.data)
      setlisttripData4(data.data);
      const data2 = await fetchTeambyName(tl1);
     //console.log(data2)
      const emplist=data2.data.filter((emp) => emp.role == "Sales" || emp.short_name==tl1 )
      setemp(emplist);
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const getTripsbyTL2 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
   try{
    if (start_date && end_date) {
      const data = await fetchConvertedTripsbyTLnDate(
        tl2,
        start_date,
        end_date
      );
      setlisttripData4(data.data);
      const data2 = await fetchTeambyName(tl2);
      const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl2  )
      setemp(emplist);
      
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const getTripsbyTL3 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl3,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl3);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  ||  emp.short_name==tl3 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

   const getTripsbyTL4 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl4,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl4);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl4 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

   const getTripsbyTL5 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl5,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl5);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl5 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

   const getTripsbyTL6 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl6,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl6);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl6 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

   const getTripsbyTL7 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl7,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl7);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl7 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

   const getTripsbyTL8 = async (start_date, end_date) => {
    setemp([])
    setlisttripData4([])
    try{
     if (start_date && end_date) {
       const data = await fetchConvertedTripsbyTLnDate(
         tl8,
         start_date,
         end_date
       );
       setlisttripData4(data.data);
       const data2 = await fetchTeambyName(tl8);
       const emplist=data2.data.filter((emp) => emp.role == "Sales"  || emp.short_name==tl8 )
       setemp(emplist);
       
     } else {
       alert("Please enter a start date and an end date before search");
     }
   }catch(err){
     console.log(err)
   }
     //console.log(listtripData)
   };

  const getconvTrips = async (start_date, end_date) => {
    try{
    //var owner="Debayan"
    if (start_date && end_date) {
      
      const data = await searchconvTripsbyDate(start_date, end_date);
      
    //  for(let i=0; i<data.data.length; i++) {
    //   // if(data.data[i].trip_id==82785){
    //   //   // console.log(total(data.data[i].cust_payments))
    //   //   // console.log(sptotal(data.data[i].supplier_payments))
    //   //   // console.log(gettaxes(data.data[i]))
    //   //   console.log(gettcs(data.data[i]))
    //   // }
    //  }
    if(role=="TL"){
      setlisttripData4(data.data.filter(t=>t.team_leader==cuser))
    }else{
      
    setlisttripData4(data.data);
    }
     
  
      const data2 = await searchLeadsbyDate(start_date, end_date);
      //console.log(data2.data)
      var temp=data2.data.filter(lead => newgetqualitylead(lead)!=="Iron" && newgetqualitylead(lead)!=="Copper" && newgetqualitylead(lead)!=="Silver")
      //console.log(temp)
      setcreatedleadData(temp);
      const data3 = await searchhotTripsbyDate2(start_date, end_date);
      const unique=removeDuplicates(data3.data, "trip_id")
      sethottripData(unique);
      const data4 = await newsearchQEbyDate2(start_date, end_date);
     
      //const temp=data4.data.filter(quote=>new Date(quote.createdAt).getTime() !== new Date(quote.updatedAt).getTime())
      //console.log(temp.length)
      setqeData(data4.data);
      const data5 = await searchcreatedTripsbyDate(start_date, end_date);
      setcreatedtripData(data5.data);
      console.log(data5.data)
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const newgetconvTrips = async (start_date, end_date) => {
    try{
    //var owner="Debayan"
    if (start_date && end_date) {
      const data = await searchconvTripsbyDate(start_date, end_date);
     
    //  for(let i=0; i<data.data.length; i++) {
    //   if(data.data[i].trip_id==82785){
    //     // console.log(total(data.data[i].cust_payments))
    //     // console.log(sptotal(data.data[i].supplier_payments))
    //     // console.log(gettaxes(data.data[i]))
    //     console.log(gettcs(data.data[i]))
    //   }
    //  }
     
          setlisttripData4(data.data);
      
      
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const getconvTrips2 = async (start_date, end_date) => {
    try{
    //var owner="Debayan"
    if (start_date && end_date) {
      const data = await searchpersonalConvTripsbyStartDate(start_date, end_date);
      //console.log(data.data)
     

      
    setlisttripData4(data.data);
      
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const b2savoidance=async()=>{
      var start_date=DateCalc(-16)
      var end_date=DateCalc(0)
      const data = await searchconvTripsbyDate(start_date, end_date);
      var temp=data.data.filter(d=>("booking" in d && "transfer_state" in d.booking && d.booking.transfer_state !=="Back to Sales") && ("cust_payments" in d && d.cust_payments.length>0 && receivedwocreditnrefund(d.cust_payments)<10000))
      setlisttripData4(temp);
  }

  const getTripsforprofitdiff = async () => {
    try{
    var data=[]
    if (searchData9.start_date && searchData9.end_date) {
      let x=prompt("Press 1 for Closed, 2 Converted, 3 for both")
      if(x==1){
          const data3 = await searchclosedTripsbyDate(searchData9.start_date, searchData9.end_date);
          data=[...data3.data]
      }else if(x==2){
          const data3 = await searchconvTripsbyDate(searchData9.start_date, searchData9.end_date);
          data=[...data3.data]
      }else{
         const data3 = await searchclosedTripsbyDate(searchData9.start_date, searchData9.end_date);
         const data2 = await searchconvTripsbyDate(searchData9.start_date, searchData9.end_date);
         data=[...data3.data, ...data2.data]
      }
      
      var temp2=removeDuplicates(data, "trip_id")
      var temp=temp2.filter(trip=>trip.freeze_profit && "booking" in trip && "hotel" in trip.booking && "land" in trip.booking && trip.booking.hotel=="Yes" && trip.booking.land=="Yes" && "transfer_state" in trip.booking && trip.booking.transfer_state=="Accepted" && !("hold_ops" in trip && trip.hold_ops))
      setlisttripData16(temp);
      var quotelist=temp.map(trip=>trip.conv_quote)
      console.log(quotelist)
      var getquotes=await fetchquotefromlist2(quotelist)
      console.log(getquotes.data)
      setquotelistdata(getquotes.data)

      var temp3=temp2.filter(trip=>trip.freeze_profit && "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Back to Sales")
      console.log(temp3)
      setprofitloss(getSumByKey(temp3, "sales_profit"))
      setexpanded5(true)
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
    //console.log(listtripData)
  };

  const getprofitquote=(tripid)=>{
    var q2=quotelistdata.filter(q=>q.trip_id==tripid)
    var q=q2.length>0?q2[0]:null
    return q && "quote_price" in q?Math.round((q.quote_price.airfare+q.quote_price.landprice+q.quote_price.taxes)-(q.cost_price.airfare+q.cost_price.landprice+q.cost_price.taxes)):0
    
  }
  

  const getEmployees = async () => {
    try{
    //const data = await fetchEmployees();
    //   //console.log(data.data)

    //   const empsplist = data.data.filter((emp) => emp.role == "TL");
    //   const empshortname = empsplist.map((emp) => emp.short_name);
    //   settl(empshortname);
    //   for(let i=0; i<empshortname.length; i++) {
    //     const data2 = await fetchTeambyName(empshortname[i])
    //     const newemp=[data2.data]
    //     console.log(newemp)
    //     //setemp(newemp)
    //   }
    const emplist3=employeelist.filter((emp) => ( emp.role == "TL" || emp.role == "SME"))
    const emplist=employeelist.filter((emp) => (emp.role == "Sales" || emp.role == "TL" || emp.role == "SME")  && emp.short_name !=="Kaushal")
    const emplist2=employeelist
    setemptl(emplist3)
    setemp3(emplist2)
    setemp(emplist);
    setemp2(emplist)
  }catch(err){
    console.log(err)
  }
    
  };

  const handleChange2=()=>{
    // if(searchbyid){
    //   setemp(emp3)
    // }else{
    //   //console.log(emp3.length)
    //   setemp(emp2)
    // }
    setsearchbyid(!searchbyid)
   
   
  }

  const handleChange3=()=>{
    // if(searchbyid){
    //   setemp(emp3)
    // }else{
    //   //console.log(emp3.length)
    //   setemp(emp2)
    // }
    setsearchbyb2s(!searchbyb2s)
   
   
  }

  const getTripsbystartdate=async()=>{
    try{
    const data=await searchConvTripsbyStartDate(searchData5.start_date, searchData5.end_date)
    
  //  for(let i=0;i<data.data.length;i++){
  //   if("status_history" in data.data[i] && data.data[i].status_history.length>0){
  //     const temp=data.data[i].status_history.filter(sh=>sh.new_status=="Converted")
  //     if(temp.length>0){
  //       data.data[i].conv_date=temp[0].date
  //     }
  //     // if(i==1){
  //     //   console.log(temp)
  //     //   console.log(data.data[i])
  //     // }
  //   } 
    
  //  }
    console.log(data.data)
    setlisttripData6(data.data)
    upsellcategory(data.data)
    setexpanded2(true)
  }catch(err){
    console.log(err)
  }
  }

  const scandocs=async(loc)=>{
    var panstring=""
   const temp=loc.split("amazonaws.com/")
   const temp2=temp[temp.length-1]
   const documentKey=temp2.replaceAll("%20"," ").replaceAll("%28","(").replaceAll("%29",")")
   //console.log(documentKey)
   const extension = documentKey.split('.').pop().toLowerCase();
   //console.log(extension)
   const panpattern = /\b[a-zA-Z]{5}\d{4}[a-zA-Z]\b/g;
 
   if(extension=="pdf"){
     const data=await analyzedocs(documentKey)
     //console.log(data.data)
    
     const data2=await getanalyzedocsresult(data.data.blocks)
     //console.log(data2.data)
     if("results" in data2.data && "Blocks" in data2.data.results){
       var text=""
       for(let i=0;i<data2.data.results.Blocks.length;i++){
         if(data2.data.results.Blocks[i].BlockType=="WORD" || data2.data.results.Blocks[i].BlockType=="LINE"){
         text=text+data2.data.results.Blocks[i].Text+" || "
         }
       }
       console.log(text)
       const panmatches = text.match(panpattern);
       console.log(panmatches)
      
       if(panmatches && panmatches.length>0){
         panstring=(panmatches.toString())
       }
     }
   }else{
   const data=await analyzedocs(documentKey)
   //console.log(data.data)
   if("blocks" in data.data){
   const temp3=data.data.blocks.filter(b=>b.BlockType=="WORD")
   //console.log(temp3)
   var text=""
   for(let i=0;i<temp3.length;i++){
     text=text+temp3[i].Text+" || "
   }
   const panmatches = text.match(panpattern);
   //console.log(panmatches)
  
   if(panmatches && panmatches.length>0){
     panstring=(panmatches.toString())
     //console.log(panstring)
   }
   }
   
   }
   return panstring
 }

  const getpan=async(triplist, tripid)=>{
    try{
      var temparr=""
      const temp=triplist.filter(d=>d.trip_id==tripid)
      const filelist="file" in temp[0] && temp[0].file.length>0?temp[0].file.filter(f=>f.type_of_doc=="PAN"):""
      //console.log(filelist)
      if(filelist.length>0){
      for(let i=0; i<filelist.length; i++){
        const loc=filelist[i].location
        const pan=await scandocs(loc)
        //console.log(pan)
        temparr=(temparr.length==0?pan:temparr+" || "+pan)
      }
      console.log(temparr)
      return temparr
    }else{
      return "xyz"
    }
    }catch(e){
      console.log(e)
    }
  }

  function getActiveTripsPerDate(trips, rangeStartISO, rangeEndISO) {
  const result = [];

  const rangeStart = new Date(rangeStartISO);
  const rangeEnd = new Date(rangeEndISO);

  // Normalize time to avoid time-zone issues
  rangeStart.setHours(0, 0, 0, 0);
  rangeEnd.setHours(0, 0, 0, 0);

  for (
    let current = new Date(rangeStart);
    current <= rangeEnd;
    current.setDate(current.getDate() + 1)
  ) {
    let count = 0;

    for (const trip of trips) {
      if (!trip.trip_start_date || trip.duration == null) continue;

      const tripStart = new Date(trip.trip_start_date);
      tripStart.setHours(0, 0, 0, 0);

      const tripEnd = new Date(tripStart);
      tripEnd.setDate(tripEnd.getDate() + trip.duration);

      if (current >= tripStart && current <= tripEnd) {
        count++;
      }
    }

    result.push({
      date: current.toISOString().split("T")[0],
      count
    });
  }

  return result;
}

  const getTripsbystartdate2=async()=>{
    try{
      setworking(true)
    const data=await searchConvTripsbyStartDate(searchData5.start_date, searchData5.end_date)
    
  //  for(let i=0;i<data.data.length;i++){
  //   if("status_history" in data.data[i] && data.data[i].status_history.length>0){
  //     const temp=data.data[i].status_history.filter(sh=>sh.new_status=="Converted")
  //     if(temp.length>0){
  //       data.data[i].conv_date=temp[0].date
  //     }
  //     // if(i==1){
  //     //   console.log(temp)
  //     //   console.log(data.data[i])
  //     // }
  //   } 
    
  //  }
    //console.log(data.data)
    //setlisttripData16(data.data)
    var temp=[]
    for(let i=0;i<data.data.length;i++){
      var tempunit={
      trip_id: data.data[i].trip_id,
      id: i,
      name: data.data[i].cust_name,
      destination:data.data[i].primary_destination,
      trip_start_date: data.data[i].trip_start_date,
      tcs:data.data[i].tcs_mail,
      pan_cust:data.data[i].pan,
      pan:await getpan(data.data, data.data[i].trip_id),
      }
      temp=[...temp, tempunit]
    }
    console.log(temp)
    setdatalistdisplay16(temp)
    setworking(false)
    setexpanded8(true)
  }catch(err){
    console.log(err)
  }
  }

  const gettcsquery=async()=>{
    try{
      setworking(true)
    const data=await fetchtcsquery(searchData5.start_date, searchData5.end_date)
    
  //  for(let i=0;i<data.data.length;i++){
  //   if("status_history" in data.data[i] && data.data[i].status_history.length>0){
  //     const temp=data.data[i].status_history.filter(sh=>sh.new_status=="Converted")
  //     if(temp.length>0){
  //       data.data[i].conv_date=temp[0].date
  //     }
  //     // if(i==1){
  //     //   console.log(temp)
  //     //   console.log(data.data[i])
  //     // }
  //   } 
    
  //  }
    console.log(data.data)
    //setlisttripData16(data.data)
    var temp=[]
    for(let i=0;i<data.data.length;i++){
      var tempunit={
      trip_id: data.data[i].trip_id,
      id: i,
      name: data.data[i].cust_name,
      destination:data.data[i].primary_destination,
      duration:data.data[i].duration,
      trip_status:data.data[i].duration,
      land_sp:data.data[i].land_sp,
      trip_start_date: data.data[i].trip_start_date,
      //tcs:data.data[i].tcs_mail,
      //pan_cust:data.data[i].pan,
      //pan:await getpan(data.data, data.data[i].trip_id),
      }
      temp=[...temp, tempunit]
    }
    console.log(temp)
    setdatalistdisplay16(temp)
    setworking(false)
    setexpanded8(true)
  }catch(err){
    console.log(err)
  }
  }

  const getTripsbystartdate3=async()=>{
    try{
      setworking(true)
      const sd=DateCalc2(searchData16.start_date, -10)
      //console.log(sd)
    const data=await searchConvTripsbyStartDate(new Date(sd), searchData16.end_date)
    //console.log(data.data)
    const temp=data.data.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales")
    //console.log(temp)

    var temp2=getActiveTripsPerDate(temp, searchData16.start_date, searchData16.end_date)
    console.log(temp2)
    const sum=getSumByKey(temp2, "count")
    const avg=sum/temp2.length
    temp2=[...temp2, {date:"Average", count:avg}]
    setlisttripData18(temp2)
    
    setworking(false)
    setexpanded21(true)
  }catch(err){
    console.log(err)
  }
  }

  const getTripsbystartdate4=async()=>{
    try{
      setworking(true)
    const data=await searchConvTripsbyStartDate(searchData15.start_date, searchData15.end_date)
    var set=data.data.filter(t=>"booking" in t && "transfer_state" in t.booking && t.booking.transfer_state=="Back to Sales")
    
  //  for(let i=0;i<data.data.length;i++){
  //   if("status_history" in data.data[i] && data.data[i].status_history.length>0){
  //     const temp=data.data[i].status_history.filter(sh=>sh.new_status=="Converted")
  //     if(temp.length>0){
  //       data.data[i].conv_date=temp[0].date
  //     }
  //     // if(i==1){
  //     //   console.log(temp)
  //     //   console.log(data.data[i])
  //     // }
  //   } 
    
  //  }
    //console.log(data.data)
    //setlisttripData16(data.data)
    var temp=[]
    for(let i=0;i<set.length;i++){
      var tempunit={
      trip_id: set[i].trip_id,
      id: i,
      name: set[i].cust_name,
      destination:set[i].primary_destination,
      trip_start_date: set[i].trip_start_date,
      trip_owner: set[i].trip_owner,
      received:onlyreceivedtotal(set[i].cust_payments),
      credit_note:creditnotetotal(set[i].cust_payments),
      refund:refundtotal(set[i].cust_payments),
      profit:getprofit(set[i]),
      total:total(set[i].cust_payments),
      sales_profit:set[i].sales_profit,
      }
      temp=[...temp, tempunit]
    }
    console.log(temp)
    setdatalistdisplay1(temp)
    setworking(false)
    setexpanded19(true)
  }catch(err){
    console.log(err)
  }
  }

    const getTripsbystartdate5=async()=>{
    try{
    setworking(true)
    const sd=DateCalc2(searchData17.start_date, -10)
      //console.log(sd)
    const data=await searchConvTripsbyStartDate(new Date(sd), new Date(searchData17.end_date))
    //console.log(data.data)
    const temp=data.data.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales" && trip.conv_quote>1)
    const quotelist=temp.map(t=>(t.conv_quote))
    //console.log(quotelist)
    const quoteData=await fetchquotefromlist(quotelist)

    var temp2=quoteData.data.sort((a,b)=>new Date(a.day.date).getTime() - new Date(b.day.date).getTime())
    var temp3=temp2.filter(t=>new Date(t.day.date)>=new Date(searchData17.start_date).getTime())
    setlisttripData19(temp3)
    
    setworking(false)
    setexpanded22(true)
  }catch(err){
    console.log(err)
  }
  }

  const getDest = async () => {
    try{
    //const data = await fetchDest();
    //const temp=data.data.filter(d=>"order" in d)
    setdest(destinationlist);
  }catch(err){
    console.log(err)
  }
  }

  useEffect(() => {
    if (!loading) {
      console.log("User:", cuser);
      console.log("Role:", role);
      console.log("Employees:", employeelist.length);
      console.log("Destinations:", destinationlist.length);
      getEmployees();
      getDest()
    }
  }, [loading, cuser, role, employeelist, destinationlist]);
  
  // useEffect(() => {
  //   getEmployees();
  //   getDest();
  // }, [cuser, role]);

  // const total = (cpdata) => {
  //   let sum = 0;
  //   if (cpdata.length == 0) {
  //     return sum;
  //   } else {
  //     cpdata.map((item) =>
  //       item.amount
  //         ? !(item.status == "Refund" || item.status=="Credit Note")
  //           ? (sum = sum + parseInt(item.amount))
  //           : (sum = sum - parseInt(item.amount))
  //         : sum
  //     );
  //     return sum;
  //   }
  // };

  const sptotal = (spdata) => {
    let sum = 0;
    if (spdata.length == 0) {
      return sum;
    } else {
      spdata.map((item) =>
        item.amount
          ? (item.status == "Refund" || item.status == "Refund Due" || item.status == "Refund claim by internal team")
            ? (sum = sum - parseInt(item.amount))
            : (sum = sum + parseInt(item.amount))
          : sum
      );
      //console.log(sum)
      return sum;
    }
  };
  //console.log(selection)
  
  const incentive=async()=>{
    try{
      var triparr=[]
      var x=prompt("Enter TL incentive:")
      //console.log(x)
      console.log(listtripData8)
      var temparr=[...listtripData8]
      for(let i=0; i<selection.length; i++){
        var temp={
          trip_id:datalistdisplay8[selection[i]].trip_id,
          
          sp_incentive:datalistdisplay8[selection[i]].sp_incentive_slab,
          incentive_paid:"Yes",
          tl_incentive:Number(x),
        }
        triparr=[...triparr, temp]
        temparr=temparr.map(trip=>trip.trip_id==datalistdisplay8[selection[i]].trip_id?{...trip,tl_incentive:Number(x),incentive_paid:"Yes"}:trip)
        // datalistdisplay8[selection[i]].tl_incentive=Number(x)
        // datalistdisplay8[selection[i]].incentive_paid="Yes"
      }
      setlisttripData8(temparr)
      console.log(temparr)
      //console.log(triparr)
      const data=await updateincentive(triparr)
      //console.log(data.data)
      
    }catch(e){
      console.log(e)
    }
  }


  const sumarray = (arr, name) => {
    // if(name=="Ajay"){
    // console.log(arr)
    // }
    let sum = 0;
    if (arr.length == 0) {
      return sum;
    } else {
      arr.map((item) => (sum = sum + item));
      return sum;
    }
  };
  const getSumByKey = (arr, key) => {
    return arr.reduce(
      (accumulator, current) => accumulator + Number(current[key]),
      0
    );
  };

  const getincentives = (profit) => {
    var incentives = 0;
    if (profit < 100000) {
      incentives = profit * 0.02;
    } else if (profit >= 100000 && profit < 150000) {
      incentives = profit * 0.04;
    } else if (profit >= 150000 && profit < 200000) {
      incentives = profit * 0.05;
    } else if (profit >= 200000 && profit < 250000) {
      incentives = profit * 0.07;
    } else if (profit >= 250000 && profit < 300000) {
      incentives = profit * 0.09;
    } else if (profit >= 300000 && profit < 350000) {
      incentives = profit * 0.11;
    } else if (profit >= 350000 && profit < 400000) {
      incentives = profit * 0.13;
    } else if (profit >= 400000) {
      incentives = profit * 0.15;
    }
    return incentives;
  };

  const markpaid=async()=>{
    var triparr=[]
      var temparr=[...listtripData8]
      for(let i=0; i<temparr.length; i++){
        var temp={...temparr[i],
          //sp_incentive_slab:temparr[i].sp_incentive_slab,
          incentive_paid:"Yes",
          //tl_incentive_slab:temparr[i].tl_incentive_slab,
          sp_incentive:temparr[i].sp_incentive_slab*100,
          tl_incentive:temparr[i].tl_incentive_slab*100,
        }
        console.log(temp)
        triparr=[...triparr, temp]
        // const updatetripResponse = await updateTripdata(
        //       temparr[i]._id,
        //       temp
        //     );
        //temparr=temparr.map(trip=>trip.trip_id==datalistdisplay8[selection[i]].trip_id?{...trip,tl_incentive:Number(x),incentive_paid:"Yes"}:trip)
        // datalistdisplay8[selection[i]].tl_incentive=Number(x)
        // datalistdisplay8[selection[i]].incentive_paid="Yes"
      }
      setlisttripData8(triparr)
      //console.log(temparr)
      //console.log(triparr)
      const data=await updateincentive(triparr)
      if (
            data.status == 200 ||
            201 ||
            202 ||
            203 ||
            204 ||
            205 ||
            206 ||
            207
          ) {
            alert("Trips Updated")
          }
  }

   const gettlincentives = (profit, spnumber, convyear) => {
    var incentives = 0;
    if (profit/spnumber < 75000) {
      incentives =  0;
    } else if (profit/spnumber >= 75000 && profit/spnumber < 125000) {
      if(convyear==2025){
          incentives =  0.01;
      }else{
          incentives =  0;
      }
    } else if (profit/spnumber >= 125000 && profit/spnumber < 150000) {
      incentives =  0.015;
    } else if (profit/spnumber >= 150000 && profit/spnumber < 175000) {
      incentives =  0.02;
    } else if (profit/spnumber >= 175000 && profit/spnumber < 200000) {
      incentives =  0.025;
    } else if (profit/spnumber >= 200000) {
      incentives =  0.03;
    }
    console.log(profit/spnumber, incentives)
    return incentives;
  };

  const getcategory=(name)=>{
 
    let sum=""
    
    const employee=emp.filter(emp=>emp.short_name==name)
    //console.log(employee)
    if(employee && employee.length>0 && "targets" in employee[0]){
      var temp=employee[0].targets.filter(m=>m.month==searchData.month)
      //console.log(temp)
      sum=temp.length>0 && "sales_category" in temp[0]?temp[0].sales_category:""
      //sum=sum+target
    }

    if(name=="Total"){
      sum=0
    }
   
    //console.log(target)
   return sum
  }
  
  var l1 = [];
  var listtripData5=[]
  var temparr=[]
  if(searchbyid){
    if(searchData.tl){
      temparr=emp3.filter(e=>e.reporting_manager==searchData.tl)
    }else{
      temparr=[...emp3]
    }
    // if(value==0 || value==1){
    //   temparr=[...emp3]
    //   }else if(value==1){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl2)
    //   }else if(value==2){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl1)
    //   }else if(value==3){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl3)
    //   }else if(value==4){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl4)
    //   }else if(value==5){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl5)
    //   }else if(value==6){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl6)
    //   }else if(value==7){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl7)
    //   }else if(value==8){
    //     temparr=emp3.filter(e=>e.reporting_manager==tl8)
    //   }
  }else{
     if(searchData.tl){
      temparr=emp.filter(e=>e.reporting_manager==searchData.tl)
    }else{
      temparr=[...emp]
    }
    // if(value==0 || value==1){
    //   temparr=[...emp]
    //   }else if(value==1){
    //     temparr=emp.filter(e=>e.reporting_manager==tl2)
    //   }else if(value==2){
    //     temparr=emp.filter(e=>e.reporting_manager==tl1)
    //   }else if(value==3){
    //     temparr=emp.filter(e=>e.reporting_manager==tl3)
    //   }else if(value==4){
    //     temparr=emp.filter(e=>e.reporting_manager==tl4)
    //   }else if(value==5){
    //     temparr=emp.filter(e=>e.reporting_manager==tl5)
    //   }else if(value==6){
    //     temparr=emp.filter(e=>e.reporting_manager==tl6)
    //   }else if(value==7){
    //     temparr=emp.filter(e=>e.reporting_manager==tl7)
    //   }else if(value==8){
    //     temparr=emp.filter(e=>e.reporting_manager==tl8)
    //   }
  }
  
  var finallist=removeDuplicates(listtripData4, "trip_id")
  
  if(searchbyb2s){
    finallist=finallist.filter(trip=>("booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state !=="Back to Sales") || trip.trip_status=="Dropped After Booking")
    
  }
  //console.log(finallist)
 if(searchData.destination){
  finallist=finallist.filter(t=>t.primary_destination==searchData.destination)
}

if(searchData.tl){
  finallist=finallist.filter(t=>t.team_leader==searchData.tl)
  var splist=finallist.map(t=>t.trip_owner)
  console.log(splist)
  var emplist=emp3.filter(e=>splist.includes(e.short_name))
  temparr=[...temparr, ...emplist]
  temparr=removeDuplicates(temparr, "employee_id")
}


  if (temparr.length > 0) {
    for (let i = 0; i < temparr.length; i++) {
      const number = finallist.filter(
        (trip) => trip.trip_owner == temparr[i].short_name
      );
    
      const leadrevenue = number.map((trip) => total(trip.cust_payments));
      const leadprofit = number.map(
        (trip) =>
         getprofit(trip)
      );
      // for(let j=0;j<number.length;j++){
      //   if(number[j].trip_id==148833 || number[j].trip_id==149907){
      //     console.log(total(number[j].cust_payments))
      //     console.log(sptotal(number[j].supplier_payments))
      //     console.log((number[j].taxes ? number[j].taxes : 0))
      //     console.log(gettcs(number[j]))
      //   }
      // }
      //const leadlandrevenue = getSumByKey(leadconverted2, "land_sp")?getSumByKey(leadconverted2, "land_sp"):0
      
      const data = {
        name: temparr[i].short_name,
        category:getcategory(temparr[i].short_name),
        revenue: sumarray(leadrevenue),
        achieved: sumarray(leadprofit, temparr[i].short_name),
        ppb:(sumarray(leadprofit, temparr[i].short_name)/(1000*number.length)).toFixed(1),
        profit_percentage: (
          sumarray(leadprofit) / sumarray(leadrevenue)
        ).toFixed(2),
        number_bookings: number.length,
        incentives: getincentives(sumarray(leadprofit)).toFixed(2),
        emp_role:temparr[i].role
      };
      l1.push(data);
        if(temparr[i].short_name=="Ajay"){
      //console.log(number)
      //console.log(data)
        }
    }

    if(searchData.category ){
      l1=l1.filter(t=>t.category!=="" && (t.category==searchData.category || t.category==0))
      
    }
    const sumtotal = {
      name: "Total",
      category:getcategory("Total"),
      revenue: getSumByKey(l1, "revenue"),
      achieved: getSumByKey(l1, "achieved"),
      ppb:(getSumByKey(l1, "achieved")/(1000*getSumByKey(l1, "number_bookings"))).toFixed(1),
      number_bookings: getSumByKey(l1, "number_bookings"),
      profit_percentage: (
        getSumByKey(l1, "achieved") / getSumByKey(l1, "revenue")
      ).toFixed(2),
      incentives: getSumByKey(l1, "incentives").toFixed(2),
    };
    l1.push(sumtotal);
    //console.log(l1)
  }
 
  l1=l1.filter(data=>data.revenue > 0 || data.emp_role=="Sales"  || data.emp_role=="SME" || data.emp_role=="TL")

  

  if(role=="Sales"  || role=="SME" ){
    listtripData5=listtripData.filter(trip => trip.trip_owner==cuser)
  }else{
    listtripData5=listtripData4
  }

  const showlandvalue=()=>{
    const leadrevenue2 = getSumByKey2(listtripData4, "land_sp")
    alert("Land part: "+leadrevenue2)
  }

  function sum( obj ) {
    var sum = 0;
    for( var el in obj ) {
      if( obj.hasOwnProperty( el ) && obj[el]!==null) {
        if(el=="airfare" || el=="landprice" || el=="otheritems"){
          sum += parseFloat( obj[el] );
        }
        
      }
    }
    return Math.round(sum);
  }

  const gettarget=(name)=>{
    var target=0
    let sum=0
    var x=[]
    const employee=employeelist.filter(emp=>emp.short_name==name)
    //console.log(employee)
    if(employee && employee.length>0 && "targets" in employee[0] && employee[0].targets.length>0){
      x=employee[0].targets.filter(t=>t.month==searchData.month)
      target=x.length>0 && "value" in x[0]?x[0].value:0
      //sum=sum+target
    }
    if(name=="Total"){
      for(let i=0; i<emp.length; i++){
        var temp=l1.filter(l=>l.name==emp[i].short_name)
        if(temp.length>0){
        if(emp[i].role=="Sales"  || emp[i].role=="SME" ){
          for(let j=0; j<emp[i].targets.length; j++){
            if(emp[i].targets[j].month==searchData.month){
              sum=sum+emp[i].targets[j].value
            }
          }
        }
      }
      }
      target=sum
    }
    //console.log(target)
   return target
  }

  const gettarget2=(name)=>{
    var target=0
    let sum=0
    var x=[]
    const employee=employeelist.filter(emp=>emp.short_name==name)
    //console.log(employee)
    if(employee && employee.length>0 && "targets" in employee[0] && employee[0].targets.length>0){
      x=employee[0].targets.filter(t=>t.month==searchData.month)
      target=x.length>0 && "conv" in x[0]?x[0].conv:0
      //sum=sum+target
    }
    if(name=="Total"){
      if(searchData.month){
      for(let i=0; i<l1.length; i++){
        var temp=emp.filter(emp=>emp.short_name==l1[i].name)
        //console.log(temp)
        if(temp.length>0){
        var temp2=temp[0].targets.filter(t=>t.month==searchData.month)
        //console.log(temp2)
        var temp3=temp2.length>0 && "conv" in temp2[0]?temp2[0].conv:0
        //console.log(temp3)
        sum=sum+temp3
        }
      }
    }
      target=sum
    }
    //console.log(target)
   return Math.round(target)
  }

  const getHot=(name)=>{
    var sum=0
   
    var temp=[...hottripData]
    if(searchData.destination){
      temp=temp.filter(trip=>trip.primary_destination==searchData.destination)
    } 
    
    temp=temp.filter(trip=>trip.trip_owner==name)
    //console.log(target)
    if(name=="Total"){
      for(let i=0 ; i<l1.length;i++){
        var temp2=hottripData.filter(trip=>trip.trip_owner==l1[i].name)
        sum=sum+temp2.length
      }
      return sum
    }else{
      return temp.length
    }
 
  }

  const getTrips=(name)=>{
    var sum=0
    var temp=[...createdtripData]
    if(searchData.destination){
      temp=temp.filter(trip=>trip.primary_destination==searchData.destination)
    } 
    temp=temp.filter(trip=>trip.trip_owner==name)
    //console.log(target)
    if(name=="Total"){
      for(let i=0 ; i<l1.length;i++){
        var temp2=createdtripData.filter(trip=>trip.trip_owner==l1[i].name)
        sum=sum+temp2.length
      }
      return sum
    }else{
      return temp.length
    }
  }

  const getQE=(name)=>{
    var sum=0
   
    var temp=[...qeData]
    if(searchData.destination){
      temp=temp.filter(trip=>trip.primary_destination==searchData.destination)
    } 
    
    temp=temp.filter(q=>q.trip_owner==name)
    //console.log(target)
    if(name=="Total"){
      for(let i=0 ; i<l1.length;i++){
        var temp2=qeData.filter(trip=>trip.trip_owner==l1[i].name)
        sum=sum+temp2.length
      }
      return sum
    }else{
      return temp.length
    }
 
  }

  const pending = (cpdata) => {
    let sum = 0;
    if (cpdata.length == 0) {
      return sum;
    } else {
      cpdata.map((item) =>
        item.amount && item.status == "Pending"
          ? (sum = sum + parseInt(item.amount))
          : sum
      );
      return sum;
    }
  };

  const geturgent=(tripid)=>{
    const temp=listtripData4.filter(trip=>trip.trip_id==tripid)
    if(temp.length>0){
      return getprofit(temp[0]) - (total(temp[0].cust_payments)-pending(temp[0].cust_payments))<0?((total(temp[0].cust_payments)-pending(temp[0].cust_payments))<10000?true:false):true
    }else{
      return ""
    }
  }

  const gettl=(name)=>{
    if(name && emp3 && emp3.length>0){
      const data=emp3.filter(emp=>emp.short_name==name)
      if(data.length>0){
        return data[0].reporting_manager
      }else{
        return ""
      }
    }else{
      return ""
    }
  }

   const upselltotal = (upsellData) => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      if(searchData5.inventory){
        upsellData.map((item) =>
            item.inventory=="Hotel Upsell Ops"?sum:
      (item.inventory==searchData5.inventory
       
          ? (sum = sum + parseInt(item.sp))
          
        : sum)
    );
      }else{
      upsellData.map((item) =>
       item.inventory=="Hotel Upsell Ops"?sum:
          (sum = sum + parseInt(item.sp))
      );
    }
      return sum;
    }
  };

  const hotelupselltotal = (upsellData) => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      if(searchData5.inventory){
        upsellData.map((item) =>
            item.inventory=="Hotel Upsell Ops"
       
          ? (sum = sum + parseInt(item.sp))
          
        : sum
    );
      }else{
      upsellData.map((item) =>
       item.inventory=="Hotel Upsell Ops"?
          (sum = sum + parseInt(item.sp)):sum
      );
    }
      return sum;
    }
  };

  const upsellprofittotal = (upsellData) => {
    let sum = 0;
    if(upsellData && Array.isArray(upsellData)){
    if (upsellData.length == 0) {
      return sum;
    } else {
   
        if(searchData5.inventory){
        upsellData.map((item) =>
      item.inventory==searchData5.inventory
       
          ?  item.inventory=="Hotel Upsell Ops"?sum:(item.inventory=="SIM" || item.inventory=="Insurance" || item.inventory=="Arrival Card"?
            (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.18)):
           (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.05)))
          
        : sum
    );
      }else{
      upsellData.map((item) =>
            item.inventory=="Hotel Upsell Ops"?sum:
           (item.inventory=="SIM" || item.inventory=="Insurance" || item.inventory=="Arrival Card"?
            (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.18)):
           (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.05)))
      );
    }
      return sum;
    }
  }else{
    return Math.round(sum)
  }
  };

   const upsellcategory = (triplist) => {
    var trips=triplist.filter(t=>"upsell" in t && t.upsell.length>0)
    var result=analyzeUpsell(trips)
    console.log(result)
    ///1=count, 2==sales,3=profit, 4=category
    var rows=Object.keys(result).map((category, index) => ({
    id: index + 1,
    category: category.toUpperCase(),
    tripCount: result[category].tripCount,
    totalSales: result[category].totalSales,
    totalCost: result[category].totalCost,
    profit: result[category].profit
  }));
  setupsellcat(rows)
  };

  function analyzeUpsell(trips) {
  const categories = ["Tour", "Hotel", "Insurance", "Arrival Card", "SIM", "Flight Fare", "Flight Ancilliary", "Others", "Forex Cash", "Forex Card", "Visa"];

  const result = {};

  // Initialize
  categories.forEach(cat => {
    result[cat] = {
      tripCount: 0,
      totalSales: 0,
      totalCost: 0,
      profit: 0
    };
  });

  trips.forEach(trip => {
    const seenInTrip = new Set();

    if (!trip.upsell || !Array.isArray(trip.upsell)) return;

    trip.upsell.forEach(item => {
      const { inventory, sp = 0, cp = 0 } = item;

      if (!categories.includes(inventory)) return;

      // Aggregate values
      result[inventory].totalSales += sp;
      result[inventory].totalCost += cp;
      result[inventory].profit += (sp - cp);

      // Count trip only once per category
      if (!seenInTrip.has(inventory)) {
        result[inventory].tripCount++;
        seenInTrip.add(inventory);
      }
    });
  });

  return result;
}

function getTargetSum(emp_record, start_date, end_date, name) {
    //const employee = emp_record.find(emp => emp.short_name === name);

    //if (!employee) return 0;

    const start = new Date(start_date);
    const end = new Date((end_date));
    //console.log(start, end)
    let total = 0;
    if(searchData.tl){
      emp_record=emp_record.filter(emp => emp.reporting_manager === searchData.tl)
    }

    // If name is "Total", calculate for all employees
    const employees = name === "Total" ? emp_record : emp_record.filter(emp => emp.short_name === name); 
    if (employees.length === 0) return 0;

    employees.forEach(employee => {
    employee.targets.forEach(item => {
        if("month" in item){
        const [monthName, year] = item.month.split(" ");
          //console.log(monthName, year)
        // Month number: January = 0, February = 1, ...
        const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
          //console.log(monthIndex)
        const monthStart = new Date(year, monthIndex, 1);
        const monthEnd = new Date(year, monthIndex + 1, 1);
          console.log(monthStart, monthEnd)
        // No overlap between this month and the requested date range
        if (monthEnd <= start || monthStart >= end) {
            return;
        }
        let days; 
        // Complete month 
        // Entire month is included 
        if (start <= monthStart && end >= monthEnd) { days = 30; } 
        // Range starts inside this month 
        else if (start > monthStart && start < monthEnd) { 
          if (end >= monthEnd) { 
          // From start date until end of month 
          days = 30 - start.getDate() + 1; } else { 
            // Both start and end are in the same month 
            days = end.getDate() - start.getDate(); } } // Range ends inside this month 
            else if (end > monthStart && end < monthEnd) { // From beginning of month until end date 
            days = end.getDate()-1; 
          }
          console.log(item.value, days)
          total += item.value * (days / 30);
        // Entire month is inside the range
        // if (monthStart >= start && monthEnd <= end) {
        //     total += item.value;
        //     return;
        // }

        // // Calculate overlapping days, assuming every month has 30 days
        //let days = 30;

        // // Partial beginning month
        // if (monthStart < start && start < monthEnd) {
        //     days -= (start.getDate() - 1);
        //     console.log(days)
        // }

        // // Partial ending month
        // if (monthStart < end && end < monthEnd) {
        //     days = end.getDate();
        //     console.log(days)
        // }
        // console.log(days)
        // total += item.value * (days / 30);
        console.log(total)
      }
    });
    })

    return Math.round(total);
  
}

  var l5=listtripData5.sort((a, b) => new Date(b.status_history.date).getTime() - new Date(a.status_history.date).getTime());

  if(searchbyb2s){
    l5=l5.filter(trip=>("booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state !=="Back to Sales") || trip.trip_status=="Dropped After Booking")
    
  }

  if(searchData.destination){
    l5=l5.filter(t=>t.primary_destination==searchData.destination)
    
  }

  if(searchData.tcs_mail){
    l5=l5.filter(t=>t.tcs_mail==searchData.tcs_mail)
    
  }

  if(searchData.ops_status){
    l5=l5.filter(t=>"booking" in t && t.booking.transfer_state==searchData.ops_status)
    
  }

  if(searchData.product_check){
    l5=l5.filter(t=>t.product_check==searchData.product_check)
    
  }

  if(searchData.reactivate){
    l5=l5.filter(t=>t.reactivate==searchData.reactivate)
    
  }
  

  l5=removeDuplicates(l5, "trip_id")

  l5=l5.sort((a, b) => new Date(b.status_history.date).getTime() - new Date(a.status_history.date).getTime());

  const datalistdisplay2 = l5.map((trip) => ({
    trip_id: trip.trip_id,
    id: l5.indexOf(trip),
    trip_owner: trip.trip_owner,
    name: getstate(trip)+trip.cust_name,
    revenue: trip.cust_payments ? total(trip.cust_payments) : 0,
    land_revenue: trip.cust_payments ? total(trip.cust_payments) - trip.anc_cp - trip.extra_cp - trip.cruise_cp - trip.flight_cp - trip.visa_cp: 0,
    profit:
      trip.cust_payments && trip.supplier_payments
        ? total(trip.cust_payments) -
          sptotal(trip.supplier_payments) -
          gettaxes(trip) -
          gettcs(trip)
        : 0,
    channel: trip.trip_channel,
    rev_pp:trip.cust_payments ? (trip.flight_sp?(parseFloat((total(trip.cust_payments)-trip.flight_sp)/((trip.number_adults+trip.number_child)*trip.duration)).toFixed(1)):parseFloat(((total(trip.cust_payments))/((trip.number_adults+trip.number_child)*trip.duration) ).toFixed(1))): "",
    flight_pp:trip.flight_sp?Number(((trip.flight_sp)/(trip.number_adults+trip.number_child)).toFixed(1)):"",
    product_check:trip.product_check,
    state: trip.cust_state,
    trip_start_date: trip.trip_start_date,
    dest:trip.primary_destination,
    special:trip.no_tax,
    only_flight:trip.only_flight,
    notcs:trip.no_tcs,
    onhold:trip.on_hold,
    duration:trip.duration,
    conv_date: "status_history" in trip ?trip.status_history.date :"",
    received: "cust_payments" in trip?(total(trip.cust_payments)-pending(trip.cust_payments)):"",
    flight_profit: trip.flight_sp && trip.flight_cp?trip.flight_sp-trip.flight_cp:"",
    quality: (("lead") in trip)?getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null):getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null),
    ops_owner:"booking" in trip && "ops_assigned" in trip.booking?trip.booking.ops_assigned:"",
    team_leader: trip.team_leader,
    manager:"team_leader" in trip && trip.team_leader?getmanager(trip.team_leader, trip.converted_date):"", 
    tcs_mail:trip.tcs_mail,
    ops_status:"booking" in trip?trip.booking.transfer_state:"",
    land_profit:Number(((getprofit(trip)/trip.land_sp)*100).toFixed(2)),
    conv_quote:trip.conv_quote,
    pax: "number_child" in trip?Number(trip.number_adults)+Number(trip.number_child):Number(trip.number_adults),
    cost:trip.cust_payments ? sptotal(trip.supplier_payments) : 0,
    gst:trip.cust_payments ?gettaxes(trip):"",
    tcs:trip.cust_payments ?gettcs(trip):"",
    next_payment_date:"cust_payments" in trip?getnextpaymentdate(trip.cust_payments):"",
    urgent: geturgent(trip),
    lead_id:"lead" in trip && "lead_id" in trip.lead?trip.lead.lead_id:"",
     upsell_profit: "upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0,
     first_installment_amount:"cust_payments" in trip && trip.cust_payments.length>0?trip.cust_payments[0].amount:"",
     total_received: "cust_payments" in trip?receivedwocreditnrefund(trip.cust_payments):"",
     b2s_date:"status_log" in trip && trip.status_log.length>0?trip.status_log[trip.status_log.length-1].transfer_state+"("+trip.status_log[trip.status_log.length-1].transfer_state_date+")":"",
     last_update_gap:"status_log" in trip && trip.status_log.length>0?Math.round((new Date(trip.status_log[trip.status_log.length-1].transfer_state_date).getTime()-new Date(trip.converted_date).getTime())/(1000*60*60*24)):"",
     briefing_call:"booking" in trip?trip.booking.briefing_call:"",
     month_end_profit:"month_end_profit" in trip?trip.month_end_profit:"",
     difference:"month_end_profit" in trip?(getprofit(trip)-trip.month_end_profit):"",
  }));

  const datalistdisplayall2 = l5.map((trip) => ({
    trip_id: trip.trip_id,
    id: l5.indexOf(trip),
    trip_owner: trip.trip_owner,
    ops_owner:"booking" in trip && "ops_assigned" in trip.booking?trip.booking.ops_assigned:"",
    name: getstate(trip)+trip.cust_name,
    quality: (("lead") in trip)?getquality(trip.lead.lead_status, trip.lead.time_to_book, trip.trip_channel, trip.trip_start_date,trip.lead.quality_upgrade,null):getquality(null, null, trip.trip_channel, trip.trip_start_date,null, null),
    revenue: trip.cust_payments ? total(trip.cust_payments) : 0,
    rev_pp:trip.cust_payments ? (trip.flight_sp?parseFloat(((total(trip.cust_payments)-trip.flight_sp)/((trip.number_adults+trip.number_child)*trip.duration)).toFixed(1)):parseFloat(((total(trip.cust_payments))/((trip.number_adults+trip.number_child)*trip.duration) ).toFixed(1))): "",
    flight_pp:trip.flight_sp?Number(((trip.flight_sp)/(trip.number_adults+trip.number_child)).toFixed(1)):"",
    land_revenue: trip.cust_payments ? total(trip.cust_payments) - trip.anc_cp - trip.extra_cp - trip.cruise_cp - trip.flight_cp - trip.visa_cp: 0,
    profit:
      trip.cust_payments && trip.supplier_payments
        ? total(trip.cust_payments) -
          sptotal(trip.supplier_payments) -
          gettaxes(trip) -
          gettcs(trip)
        : 0,
    product_check:trip.product_check,
    received: "cust_payments" in trip?(total(trip.cust_payments)-pending(trip.cust_payments)):"",
    channel: trip.trip_channel,
    state: trip.cust_state,
    trip_start_date: trip.trip_start_date,
    dest:trip.primary_destination,
    duration:trip.duration,
    special:trip.no_tax,
    only_flight:trip.only_flight,
    notcs:trip.no_tcs,
    onhold:trip.on_hold,
    conv_date: trip.converted_date,
    team_leader: trip.team_leader,
    manager:"team_leader" in trip && trip.team_leader?getmanager(trip.team_leader, trip.converted_date):"", 
    ops_status:"booking" in trip?trip.booking.transfer_state:"",
    tcs_mail:trip.tcs_mail,
    land_profit:Number(((getprofit(trip)/trip.land_sp)*100).toFixed(2)),
    conv_quote:trip.conv_quote,
    pax: "number_child" in trip?Number(trip.number_adults)+Number(trip.number_child):Number(trip.number_adults),
    flight_profit: trip.flight_sp && trip.flight_cp?trip.flight_sp-trip.flight_cp:"",
    cost:trip.cust_payments ? sptotal(trip.supplier_payments) : 0,
    gst:trip.cust_payments ?gettaxes(trip):"",
    tcs:trip.cust_payments ?gettcs(trip):"",
    inc_profit:trip.supplier_payments && trip.supplier_payments && trip.sales_profit
        ? (total(trip.cust_payments) -
          sptotal(trip.supplier_payments) -
          gettaxes(trip) -
          gettcs(trip)) - trip.sales_profit
        : "",
     next_payment_date:"cust_payments" in trip?getnextpaymentdate(trip.cust_payments):"",
     urgent: geturgent(trip),
     lead_id:"lead" in trip && "lead_id" in trip.lead?trip.lead.lead_id:"",
     incentive_paid:"incentive_paid" in trip? trip.incentive_paid:"",
     tl_incentive: "tl_incentive" in trip? trip.tl_incentive:"",
     sp_incentive:"sp_incentive" in trip? trip.sp_incentive:"",
      upsell_profit: "upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0,
        first_installment_amount:"cust_payments" in trip && trip.cust_payments.length>0?trip.cust_payments[0].amount:"",
     total_received: "cust_payments" in trip?receivedwocreditnrefund(trip.cust_payments):"",
     b2s_date:"status_log" in trip && trip.status_log.length>0?trip.status_log[trip.status_log.length-1].transfer_state+"("+trip.status_log[trip.status_log.length-1].transfer_state_date+")":"",
     last_update_gap:"status_log" in trip && trip.status_log.length>0?Math.round((new Date(trip.status_log[trip.status_log.length-1].transfer_state_date).getTime()-new Date(trip.converted_date).getTime())/(1000*60*60*24)):"",
     briefing_call:"booking" in trip?trip.booking.briefing_call:"",
     month_end_profit:"month_end_profit" in trip?trip.month_end_profit:"",
     difference:"month_end_profit" in trip?(getprofit(trip)-trip.month_end_profit):"",
     model_beta:"lead" in trip && "model_beta" in trip.lead? trip.lead.model_beta:"",
     
  }));

  

  var datalistdisplay = l1.map((data) => ({
    name: data.name,
    category:getcategory(data.name),
    id: l1.indexOf(data),
    revenue: data.revenue,
    achieved: data.achieved,
    ppb:data.ppb,
    num_trips:getTrips(data.name),
    conv_req: gettarget2(data.name),
    hot_req: gettarget2(data.name)*4,
    num_hot_till_now:Math.round(gettarget2(data.name)*(4*new Date().getDate())/30),
    num_qe_req:Math.round(gettarget2(data.name)*(22*new Date().getDate())/30),
    num_qe:getQE(data.name),
    num_hot:getHot(data.name),
    h2c:Math.round(data.number_bookings/getHot(data.name)*100),
    qe2h:Math.round(getHot(data.name)/getQE(data.name)*100),
    profit_percentage: data.profit_percentage,
    number_bookings: data.number_bookings,
    incentives: data.incentives,
    //targets:gettarget(data.name),
    targets:"type" in searchData && searchData.type=="Multiple"?getTargetSum(employeelist, searchData.start_date, searchData.end_date, data.name):gettarget(data.name),
    quality: (("lead") in data)?getquality(data.lead.lead_status, data.lead.time_to_book, data.trip_channel, data.trip_start_date,data.lead.quality_upgrade,null):getquality(null, null, data.trip_channel, data.trip_start_date,null, null),
    tl:gettl(data.name),
  }));

  var datalistdisplayall = l1.map((data) => ({
    name: data.name,
    id: l1.indexOf(data),
    category:getcategory(data.name),
    revenue: data.revenue,
    achieved: data.achieved,
    ppb:data.ppb,
    num_trips:getTrips(data.name),
    conv_req: gettarget2(data.name),
    hot_req: gettarget2(data.name)*4,
    num_hot_till_now:Math.round(gettarget2(data.name)*(4*new Date().getDate())/30),
    num_qe_req:Math.round(gettarget2(data.name)*(22*new Date().getDate())/30),
    num_qe:getQE(data.name),
    num_hot:getHot(data.name),
    h2c:Math.round(data.number_bookings/getHot(data.name)*100),
    qe2h:Math.round(getHot(data.name)/getQE(data.name)*100),
    profit_percentage: data.profit_percentage,
    number_bookings: data.number_bookings,
    incentives: data.incentives,
    //targets:gettarget(data.name),
    targets:"type" in searchData && searchData.type=="Multiple"?getTargetSum(employeelist, searchData.start_date, searchData.end_date, data.name):gettarget(data.name),
    quality: (("lead") in data)?getquality(data.lead.lead_status, data.lead.time_to_book, data.trip_channel, data.trip_start_date,data.lead.quality_upgrade,null):getquality(null, null, data.trip_channel, data.trip_start_date,null, null),
    tl:gettl(data.name),
  }));

  var l11=[{
    category:"Less than 8k",
    count:0
  },
  {
    category:"Between 8k & 15k",
    count:0
  },
  {
    category:"Between 15k & 25k",
    count:0
  },
  {
    category:"Between 25k & 40k",
    count:0
  },
  {
    category:"Between 40k & 70k",
    count:0
  },
  {
    category:"Between 70k & 100k",
    count:0
  },
  {
    category:"Greater than 100k",
    count:0
  },
]
var totalttc=0
  if(finallist.length>0){
    var finallist2=finallist.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales")
    for(let i=0;i<finallist2.length;i++){
      var ttc=(new Date(finallist2[i].trip_start_date).getTime()-new Date(getconvdate(finallist2[i])).getTime())/(1000*60*60*24)
      var x=getprofit(finallist2[i])
      totalttc=totalttc+ttc
      //console.log(ttc, x)
      if(x<8000){
        l11=l11.map(d=>d.category=="Less than 8k"?{category:"Less than 8k", count:d.count+1}:d)
        continue
      }else if(x>=8000 && x<15000){
        l11=l11.map(d=>d.category=="Between 8k & 15k"?{category:"Between 8k & 15k", count:d.count+1}:d)
        continue
      }else if(x>=15000 && x<25000){
        l11=l11.map(d=>d.category=="Between 15k & 25k"?{category:"Between 15k & 25k", count:d.count+1}:d)
        continue
      }else if(x>=25000 && x<40000){
        l11=l11.map(d=>d.category=="Between 25k & 40k"?{category:"Between 25k & 40k", count:d.count+1}:d)
        continue
      }else if(x>=40000 && x<70000){
        l11=l11.map(d=>d.category=="Between 40k & 70k"?{category:"Between 40k & 70k", count:d.count+1}:d)
        continue
      }else if(x>=70000 && x<100000){
        l11=l11.map(d=>d.category=="Between 70k & 100k"?{category:"Between 70k & 100k", count:d.count+1}:d)
        continue
      }else{
         l11=l11.map(d=>d.category=="Greater than 100k"?{category:"Greater than 100k", count:d.count+1}:d)
         continue
      }
      
    }
  }
 
  var datalistdisplay17 = l11.map((data) => ({
    category: data.category,
    id: l11.indexOf(data),
    count:data.count,
    count_perc:(data.count/finallist.length*100).toFixed(1)
  }));
  //console.log(finallist);
  //console.log(l11);
  // console.log(totalttc);
  const getTripsbyreceipt = async (startdate, enddate) => {
    try{
    if (startdate && enddate) {
      const data = await fetchtripsbyreceipt(startdate, enddate);
      const temp=data.data.filter(t=>pending(t.cust_payments)==0 && new Date(t.cust_payments[t.cust_payments.length-1].date).getTime()>new Date(startdate).getTime() && new Date(t.cust_payments[t.cust_payments.length-1].date).getTime()<new Date(enddate).getTime())
      if(finalinstallmentflag){
        setlisttripData2(temp);
      }else{
        setlisttripData2(data.data);
      }
      
      setexpanded6(true)
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  };

  const getTripsbyaccount = async (account) => {
   try{
     if (account) {
      var finaldata=[]
      const data = await fetchtripsbyaccount(account);
      console.log(data.data)
      for(let i=0;i<data.data.length;i++){
        if(data.data[i].cust_payments.length>0){
          
          //console.log(temp)
        
            for(let j=0;j<data.data[i].cust_payments.length;j++){
              var temp2={
              trip_id:data.data[i].trip_id,
              account:data.data[i].cust_payments[j].account,
              amount:data.data[i].cust_payments[j].amount,
              cust_name:data.data[i].cust_name,
            }
            finaldata=[...finaldata, temp2]
            }
            
          
        }
         if(data.data[i].supplier_payments.length>0){
          
          //console.log(stemp)
        
            for(let j=0;j<data.data[i].supplier_payments.length;j++){
              var stemp2={
              trip_id:data.data[i].trip_id,
              account:data.data[i].supplier_payments[j].account,
              amount:-data.data[i].supplier_payments[j].amount,
              cust_name:data.data[i].cust_name,
            }
            finaldata=[...finaldata, stemp2]
            }
            
          
        }
      }
      const total={
         trip_id:"Total",
              account:"",
              amount:getSumByKey(finaldata, "amount"),
              cust_name:"",
      }
      finaldata=[...finaldata, total]
      console.log(finaldata)
      setlisttripData17(finaldata)
      setexpanded11(true)
    
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  };

  const getTripsbyrefund = async (startdate, enddate) => {
    try{
    if (startdate && enddate) {
      const data = await fetchtripsbyrefund(startdate, enddate);
      // const temp=data.data.filter(t=>pending(t.cust_payments)==0)
      // if(finalinstallmentflag){
      setlisttripData7(data.data);
      // }else{
      //   setlisttripData2(data.data);
      // }
      
    setexpanded1(true)
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  };

   const getTripsbyreceived = async (startdate, enddate) => {
    try{
     if (startdate && enddate) {
      var finaldata=[]
      const data = await fetchtripsbyreceipt(startdate, enddate);
      for(let i=0;i<data.data.length;i++){
        if(data.data[i].cust_payments.length>0){
          var temp=data.data[i].cust_payments.filter(c=>c.status!=="Pending" && "account" in c && c.account.startsWith("SC"))
          //console.log(temp)
          if(temp.length>0){
            for(let j=0;j<temp.length;j++){
              var temp2={
              trip_id:data.data[i].trip_id,
              account:temp[j].account,
              amount:temp[j].amount,
              cust_name:data.data[i].cust_name,
            }
            finaldata=[...finaldata, temp2]
            }
            
          }
        }
         if(data.data[i].supplier_payments.length>0){
          var stemp=data.data[i].supplier_payments.filter(c=>c.status!=="Pending" && "account" in c && c.account.startsWith("SC"))
          //console.log(stemp)
          if(stemp.length>0){
            for(let j=0;j<stemp.length;j++){
              var stemp2={
              trip_id:data.data[i].trip_id,
              account:temp[j].account,
              amount:-temp[j].amount,
              cust_name:data.data[i].cust_name,
            }
            finaldata=[...finaldata, stemp2]
            }
            
          }
        }
      }
      const total={
         trip_id:"Total",
              account:"",
              amount:getSumByKey(finaldata, "amount"),
              cust_name:"",
      }
      finaldata=[...finaldata, total]
      console.log(finaldata)
      setlisttripData17(finaldata)
      setexpanded11(true)
    
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  };

  const getTripsbysupplierrefund = async (startdate, enddate) => {
    try{
    if (startdate && enddate) {
      const data = await fetchtripsbysupplierrefund(startdate, enddate);
      // const temp=data.data.filter(t=>pending(t.cust_payments)==0)
      // if(finalinstallmentflag){
      setlisttripData9(data.data);
      // }else{
      //   setlisttripData2(data.data);
      // }
      
      setexpanded3(true)
    } else {
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  };

  const getTripsbypaid = async (startdate, enddate) => {
    try{
    if (startdate && enddate) {
      var data=[]
      var findata=[]
      if(searchbypending){
       data = await fetchtripsbysupplierpending(startdate, enddate);
      // console.log(data.data)
      // setlisttripData3(data.data);
      }else if(searchbyinternalteam){
        data = await fetchtripsbypaidinternalteam(startdate, enddate);
      }else{
        data = await fetchtripsbypaid(startdate, enddate);
      
      }
      console.log(data.data)
      for (let i=0;i<data.data.length;i++){
        // for(let j=0;j<data.data[i].supplier_payments.length;j++){
          //  if(new Date(data.data[i].supplier_payments.date).getTime() >=new Date(startdate).getTime() && new Date(data.data[i].supplier_payments.date).getTime()<=new Date(enddate).getTime()){
              var temp={
                trip_id:data.data[i].trip_id,
                trip_owner:data.data[i].trip_owner,
                name:data.data[i].cust_name,
                trip_start_date:data.data[i].trip_start_date,
                amount:data.data[i].supplier_payments.amount,
                
                supplier:data.data[i].supplier_payments.name,
                status:data.data[i].supplier_payments.status,
                only_flight:data.data[i].only_flight,
                no_tcs:data.data[i].no_tcs,
                no_tax:data.data[i].no_tax,
                payment_date:data.data[i].supplier_payments.date,
              }
              findata=[...findata, temp]
           //}
           
        // }
      }
      console.log(findata)
      setlisttripData3(findata);
    } else {
      alert("Please enter a start date and an end date before search");
    }
    setexpanded4(true)
  }catch(err){
    console.log(err)
  }
  };

  const getbychangelog=async(startdate, enddate)=>{
    try{
    const data=await fetchtripsbychangelog(startdate, enddate)
    console.log(data.data)
    var temp=removeDuplicatesbysortingkey(data.data, "trip_id", "changelog.changed_date")
    setlisttripData28(temp.filter(t=>t.changelog.changed_by!=="Amit" && t.changelog.new_profit-t.changelog.old_profit<-100))
    }catch(err){
      console.log(err)
    }
  }

  const getamount=(cp, value)=>{
    let sum=0, count=0
    for(let i=0; i<cp.length; i++) {
      if(new Date(cp[i].date).getTime() >=new Date(searchData2.start_date).getTime() && new Date(cp[i].date).getTime()<=new Date(searchData2.end_date).getTime()){
        count++
        if(cp[i].status=="Received"){
        sum+=cp[i].amount
        }
      }
    }
    if(value==1){
      return sum
    }else{
      return count
    }
  }

  const getamount2=(sp, value)=>{
    let temp={}
    for(let i=0; i<sp.length; i++) {
      if(new Date(sp[i].date).getTime() >=new Date(searchData3.start_date).getTime() && new Date(sp[i].date).getTime()<=new Date(searchData3.end_date).getTime()){
        // count++
        if(sp[i].status=="Paid" || sp[i].status=="Pending"){
          // sum+=sp[i].amount
          temp={
            amount:sp[i].amount,
            name:sp[i].name,
          }
          }
       
      }
    }
    if(value==1){
      return temp.amount
    }else{
      return temp.name
    }
  }

  const freezemonthendprofit=async()=>{
    try{
      const result = datalistdisplay2.map((t) => ({trip_id:t.trip_id, profit:t.profit}));
    
    const freezeprofitresponse=await freezeprofit(result)
    if(freezeprofitresponse.data.length==result.length){
      alert("Successfully Updated")
    }
    }catch(err){
      console.log(err)
    }
  }

  

  //console.log(listtripData7)
  const datalistdisplay3 = listtripData2.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData2.indexOf(trip),
    trip_owner: trip.trip_owner,
    dest:trip.primary_destination,
    name: trip.cust_name,
    trip_start_date: trip.trip_start_date,
    amount: "cust_payments" in trip?getamount(trip.cust_payments, 1):0,
    count: "cust_payments" in trip?getamount(trip.cust_payments, 0):0,
    notax:trip.no_tax,
    notcs:trip.no_tcs,
    of:trip.only_flight,
    tcs_mail:trip.tcs_mail,
    
  }));

  const datalistdisplay4 = listtripData3.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData3.indexOf(trip),
    trip_owner: trip.trip_owner,
    name: trip.name,
    trip_start_date: trip.trip_start_date,
    amount: trip.amount,
    status: trip.status,
    supplier_name: trip.supplier,
    no_tax:trip.no_tax,
    no_tcs:trip.no_tcs,
    only_flight:trip.only_flight,
    payment_date:trip.payment_date,
  }));

  const datalistdisplay7 = listtripData7.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData7.indexOf(trip),
    trip_owner: trip.trip_owner,
    dest:trip.primary_destination,
    name: trip.cust_name,
    trip_start_date: trip.trip_start_date,
    amount: "cust_payments" in trip?trip.cust_payments.amount:0,
    count: "cust_payments" in trip?trip.cust_payments.status:0,
    notax:trip.no_tax,
    notcs:trip.no_tcs,
    of:trip.only_flight,
    tcs_mail:trip.tcs_mail,
    
  }));

  const datalistdisplay9 = listtripData9.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData9.indexOf(trip),
    trip_owner: trip.trip_owner,
    dest:trip.primary_destination,
    name: trip.cust_name,
    trip_start_date: trip.trip_start_date,
    amount: "supplier_payments" in trip?trip.supplier_payments.amount:0,
    count: "supplier_payments" in trip?trip.supplier_payments.status:0,
    notax:trip.no_tax,
    notcs:trip.no_tcs,
    of:trip.only_flight,
    tcs_mail:trip.tcs_mail,
    supplier:"supplier_payments" in trip?trip.supplier_payments.name:0,
  }));

  var sumrefundue=0
  if(datalistdisplay9.length>0){
  var tempdue=datalistdisplay9.filter(d=>d.count=="Refund Due")

  sumrefundue=getSumByKey(tempdue, "amount")
  }

  const gridcellclickpayment = (id) => {
    window.open("/tripdataentry/" + id + "/paymentupdate", "_blank");
    //console.log("/custdataentry/"+id);
  };

  const gridcellclick = (id) => {
    window.open("/tripdataentry/" + id, "_blank");
    //console.log("/custdataentry/"+id);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if(newValue==1){
      //getTripsbyTL2(searchData.start_date, searchData.end_date)
       getconvTrips(searchData.start_date, searchData.end_date)
      getEmployees()
    }else if(newValue==2){
      getTripsbyTL(searchData.start_date, searchData.end_date)
    }else if(newValue==3){
      getTripsbyTL3(searchData.start_date, searchData.end_date)
    }else if(newValue==4){
      getTripsbyTL4(searchData.start_date, searchData.end_date)
    }else if(newValue==5){
      getTripsbyTL5(searchData.start_date, searchData.end_date)
    }else if(newValue==6){
      getTripsbyTL6(searchData.start_date, searchData.end_date)
    }else if(newValue==7){
      getTripsbyTL7(searchData.start_date, searchData.end_date)
    }else if(newValue==8){
      getTripsbyTL8(searchData.start_date, searchData.end_date)
    }else if(newValue==0){
      getconvTrips(searchData.start_date, searchData.end_date)
      getEmployees()
    }
  };

  const getdestmc=(dest)=>{
    var desttype=0
    switch (dest) {
      case "Kashmir":
        desttype = 200;
        break;
      case "Himachal":
        desttype = 90;
        break;
      case "Andaman":
        desttype = 60;
        break;
      case "Goa":
        desttype = 85;
        break;
      case "Rajasthan":
        desttype = 85;
        break;
      case "Dubai":
        desttype = 95;
        break;
        case "Turkey":
        desttype = 250;
        break;
      case "Sikkim-Darjeeling":
        desttype = 90;
        break;
      case "Uttarakhand":
        desttype = 85;
        break;
      case "Kerala":
        desttype = 85;
        break;
      case "North-East":
        desttype = 85;
        break;
      case "Thailand":
        desttype = 75;
        break;
      case "Indonesia":
        desttype = 120;
        break;
      case "Vietnam":
        desttype = 60;
        break;
      case "Maldives":
        desttype = 250;
        break;
      case "Mauritius":
        desttype = 120;
        break;
      case "Singapore":
        desttype = 120;
        break;
      case "Malaysia":
        desttype = 90;
        break;
      case "Ladakh":
        desttype = 85;
        break;
      case "Sri Lanka":
          desttype = 250;
          break;
      default:
        desttype = 0;
  
  }
    return desttype
  }

  

 
  var l17=[...listtripData17]
 if(listtripData17.length>0 && "account" in filterData && filterData.account){
    l17=l17.filter(l=>l.account==filterData.account)
     const total={
         trip_id:"Total",
              account:"",
              amount:getSumByKey(l17, "amount"),
              cust_name:"",
      }
      l17=[...l17, total]
 }
  //dest wise calc for tab 2
  var l2 = [];
  var finallist2=removeDuplicates(listtripData4, "trip_id")
  if (dest.length > 0) {
    for (let i = 0; i < dest.length; i++) {
      var numberlead = createdleadData.filter(
        (lead) => lead.lead_destination == dest[i]
      );
      if (dest[i] == "Indonesia") {
        numberlead = createdleadData.filter(
          (lead) => lead.lead_destination == "Bali" || lead.lead_destination == "Indonesia"
        );
      }

       if (dest[i] == "Dubai") {
        numberlead = createdleadData.filter(
          (lead) => lead.lead_destination == "Dubai" || lead.lead_destination == "Abu Dhabi"
        );
      }
      //console.log(numberlead)
      const number2 = finallist2.filter(
        (trip) => trip.primary_destination == dest[i]
      );
      const leadrevenue = number2.map((trip) => total(trip.cust_payments));
      const leadflight = number2.map((trip) => trip.flight_sp?trip.flight_sp:0);
      const leadprofit = number2.map(
        (trip) =>
        total(trip.cust_payments) -
        sptotal(trip.supplier_payments) -
        (trip.taxes ? trip.taxes : 0) -
        gettcs(trip)
      );
      const data2 = {
        name: dest[i],
        revenue: sumarray(leadrevenue),
        land_revenue: sumarray(leadrevenue)-sumarray(leadflight),
        achieved: sumarray(leadprofit),
        profit_percentage: (
          sumarray(leadprofit) / (sumarray(leadrevenue)-sumarray(leadflight))
        ).toFixed(2),
        number_bookings: number2.length,
        ops_cost: numberlead.length * 100 + sumarray(leadprofit) * 0.06+number2.length*3000,
        ops_cm:
          sumarray(leadprofit) -
          numberlead.length * 100 -
          sumarray(leadprofit) * 0.06-number2.length*3000,
        cm:
          sumarray(leadprofit) -
          numberlead.length * 200 -
          numberlead.length * 100-
          sumarray(leadprofit) * 0.06
          -number2.length*3000,
        cost: numberlead.length * 200,
        cm_lead:((sumarray(leadprofit) -
          numberlead.length * 200 -
          numberlead.length * 100-
          sumarray(leadprofit) * 0.06
          -number2.length*3000)/numberlead.length).toFixed(2),
        cm_perc:((sumarray(leadprofit) -
        numberlead.length * 100 - numberlead.length * 200 -
        sumarray(leadprofit) * 0.06
        -number2.length*3000)*100/(sumarray(leadrevenue)-sumarray(leadflight))).toFixed(2)
      };
      l2.push(data2);
    }
    const sumtotal2 = {
      name: "Total",
      revenue: getSumByKey(l2, "revenue"),
      land_revenue: getSumByKey(l2, "land_revenue"),
      achieved: getSumByKey(l2, "achieved"),
      number_bookings: getSumByKey(l2, "number_bookings"),
      profit_percentage: (
        getSumByKey(l2, "achieved") / getSumByKey(l2, "revenue")
      ).toFixed(2),
      ops_cost:
        createdleadData.length * 100 + getSumByKey(l2, "achieved") * 0.06+getSumByKey(l2, "number_bookings")*3000,
      ops_cm:
        getSumByKey(l2, "achieved") -
        createdleadData.length * 100 -
        getSumByKey(l2, "achieved") * 0.06 - getSumByKey(l2, "number_bookings")*3000,
      cost: getSumByKey(l2, "cost"),
      cm:
        getSumByKey(l2, "achieved") -
        createdleadData.length * 100 - getSumByKey(l2, "cost") -
        getSumByKey(l2, "achieved") * 0.06-
        getSumByKey(l2, "number_bookings")*3000,
      cm_lead:((getSumByKey(l2, "achieved") -
        createdleadData.length * 100 - getSumByKey(l2, "cost") -
        getSumByKey(l2, "achieved") * 0.06-
        getSumByKey(l2, "number_bookings")*3000)/(createdleadData.length)).toFixed(2),
      cm_perc:Math.round((getSumByKey(l2, "achieved") -
      createdleadData.length * 200 -
      getSumByKey(l2, "achieved") * 0.06-
      getSumByKey(l2, "number_bookings")*3000)*100/getSumByKey(l2, "revenue"))
    };
    l2.push(sumtotal2);
  }

 
  const datalistdisplay5 = l2.map((data) => ({
    name: data.name,
    id: l2.indexOf(data),
    revenue: data.revenue,
    land_revenue: data.land_revenue,
    achieved: data.achieved,
    profit_percentage: data.profit_percentage,
    number_bookings: data.number_bookings,
    cost: Math.round(data.cost),
    ops_cost: Math.round(data.ops_cost),
    ops_cm: Math.round(data.ops_cm),
    cm: Math.round(data.cm),
    cm_lead:data.cm_lead,
    cm_perc:Math.round(data.cm_perc)
  }));

  var l16=[...listtripData6]
  if(searchData5.pitch){
    if(searchData5.pitch=="Hotel"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.hotel)
    }
    if(searchData5.pitch=="Tour"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.tour)
    }
    if(searchData5.pitch=="Insurance"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.insurance)
    }
    if(searchData5.pitch=="Arrival Card"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.ac)
    }
    if(searchData5.pitch=="Forex Card" || searchData5.pitch=="Forex Cash"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.forex)
    }
    if(searchData5.pitch=="SIM"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.sim)
    }
    if(searchData5.pitch=="Visa"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.visa)
    }
    if(searchData5.pitch=="Others" || searchData5.pitch=="Flight Fare" || searchData5.pitch=="Flight Ancilliary"){
      l16=l16.filter(t=>"upsell_pitch" in t && t.upsell_pitch.others)
    }
  }

  if(searchData5.eligible){
    if(searchData5.eligible=="Hotel"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Tour"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Insurance"){
      l16=l16.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Arrival Card"){
      l16=l16.filter(t=>(t.primary_destination=="Indonesia" ||t.primary_destination=="Thailand" || t.primary_destination=="Singapore" || t.primary_destination=="Malaysia" ||t.primary_destination=="Vietnam") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Forex Card" || searchData5.eligible=="Forex Cash"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="SIM"){
      l16=l16.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Visa"){
      l16=l16.filter(t=>(t.primary_destination=="Indonesia") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
    if(searchData5.eligible=="Others" || searchData5.eligible=="Flight Fare" || searchData5.eligible=="Flight Ancilliary"){
      l16=l16.filter(t=>t.flight_cp>0 && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
    }
  }

   if(searchData5.eligiblenopitch){
    if(searchData5.eligiblenopitch=="Hotel"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.hotel))
    }
    if(searchData5.eligiblenopitch=="Tour"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.tour))
    }
    if(searchData5.eligiblenopitch=="Insurance"){
      l16=l16.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.insurance))
    }
    if(searchData5.eligiblenopitch=="Arrival Card"){
      l16=l16.filter(t=>(t.primary_destination=="Indonesia" ||t.primary_destination=="Thailand" || t.primary_destination=="Singapore" || t.primary_destination=="Malaysia" ||t.primary_destination=="Vietnam") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.ac))
    }
    if(searchData5.eligiblenopitch=="Forex Card" || searchData5.eligiblenopitch=="Forex Cash"){
      l16=l16.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.forex))
    }
    if(searchData5.eligiblenopitch=="SIM"){
      l16=l16.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.sim))
    }
    if(searchData5.eligiblenopitch=="Visa"){
      l16=l16.filter(t=>(t.primary_destination=="Indonesia") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.visa))
    }
    if(searchData5.eligiblenopitch=="Others" || searchData5.eligiblenopitch=="Flight Fare" || searchData5.eligiblenopitch=="Flight Ancilliary"){
      l16=l16.filter(t=>t.flight_cp>0 && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("upsell_pitch" in t && t.upsell_pitch.others))
    }
  }

  const datalistdisplay6 = l16.map((trip) => ({
    trip_id: trip.trip_id,
    id: l16.indexOf(trip),
    trip_owner: trip.trip_owner,
    trip_status: trip.trip_status,
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    conv_date:getconvdate(trip),
    upsell_value: "upsell" in trip && trip.upsell.length>0?upselltotal(trip.upsell):0,
    upsell_profit: "upsell" in trip && trip.upsell.length>0?Math.round(upsellprofittotal(trip.upsell)):0,
    tcs:gettcs(trip),
    tl_incentive:"tl_incentive" in trip?trip.tl_incentive:"",
    sp_incentive:"sp_incentive" in trip?trip.sp_incentive:"",
    incentive_paid:"incentive_paid" in trip?trip.incentive_paid:"",
    profit:"cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0,
    
  }));

    const datalistdisplay6b = l16.map((trip) => ({
    trip_id: trip.trip_id,
    id: l16.indexOf(trip),
    trip_owner: trip.trip_owner,
    trip_status: trip.trip_status,
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    conv_date:getconvdate(trip),
    upsell_value: "upsell" in trip && trip.upsell.length>0?hotelupselltotal(trip.upsell):0,
    upsell_profit: "upsell" in trip && trip.upsell.length>0?Math.round(hotelupsellprofittotal(trip.upsell)):0,
    // tcs:gettcs(trip),
    // tl_incentive:"tl_incentive" in trip?trip.tl_incentive:"",
    // sp_incentive:"sp_incentive" in trip?trip.sp_incentive:"",
    // incentive_paid:"incentive_paid" in trip?trip.incentive_paid:"",
    profit:"cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0,
    
  }));

  const datalistdisplay10 = listtripData16.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData16.indexOf(trip),
    trip_owner: trip.trip_owner,
    ops_owner:"booking" in trip?trip.booking.ops_assigned:"",
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    conv_date:getconvdate(trip),
    old_profit:trip.sales_profit,
    current_profit:"cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0,
    diff: ("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)-trip.sales_profit,
    old_profit_perc:"cust_payments" in trip && "supplier_payments" in trip?((trip.sales_profit/trip.land_sp)*100).toFixed(2):"",
    new_profit_perc: "cust_payments" in trip && "supplier_payments" in trip?((getprofit(trip)/trip.land_sp)*100).toFixed(2):"",
    diff_profit_perc:"cust_payments" in trip && "supplier_payments" in trip?(((getprofit(trip)/trip.land_sp)-(trip.sales_profit/trip.land_sp))*100).toFixed(2):"",
    flight_profit:"flight_sp" in trip && "flight_cp" in trip?trip.flight_sp-trip.flight_cp:0,
    diff_without_flight:("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)-trip.sales_profit-("flight_sp" in trip && "flight_cp" in trip?trip.flight_sp-trip.flight_cp:0),
    ops_note:"trip_id" in trip?getcomment(trip, "Ops", 1):"",
    quote_profit:"trip_id" in trip && quotelistdata && quotelistdata.length>0?getprofitquote(trip.trip_id):""
  }));

  const datalistdisplay18=l17.map(data=>({
    id:listtripData17.indexOf(data),
    trip_id:data.trip_id,
    cust_name:data.cust_name,
    account:data.account,
    amount:data.amount,
  }))

  const sumdiff=getSumByKey(datalistdisplay10, "diff")
  const sumdiff2=getSumByKey(datalistdisplay10, "diff_without_flight")


  const changemonth=(value)=>{
    var x=getmonth(value)
    //console.log(x)
    setsearchData({...searchData, start_date:new Date(x.startdate), end_date:new Date(x.enddate), month:value, type:"Single"})
    setsearchData4({...searchData4, start_date:new Date(x.startdate), end_date:new Date(x.enddate), month:value})
  }
  //console.log(searchData.end_date)
  

  const sppending = (spdata) => {
    let sum = 0;
    if (spdata.length == 0) {
      return sum;
    } else {
      spdata.map((item) =>
        item.amount && item.status == "Pending"
          ? (sum = sum + parseInt(item.amount))
          : sum
      );
      return sum;
    }
  };

  const showrp=async()=>{
    let ar=0
    let ap=0
    const d1=DateCalc(0)
    const d2=new Date("2023-04-01")
    const data=await searchconvTripsbyDate(d2, d1)
    for(let i=0;i<data.data.length;i++){
      ar=ar+pending(data.data[i].cust_payments)
      ap=ap+sppending(data.data[i].supplier_payments)
    }
   alert("Accounts Receivable: "+ar+"\n\nAccounts Payable: "+ap+"\n\nDifference: "+(ar-ap))
  }

  const getslab=(sum)=>{
    if(sum < 100000){
      return 0.02
    }else if(sum>=100000 && sum < 150000){
      return 0.04
    }else if(sum>=150000 && sum < 200000){
      return 0.05
    }else if(sum>=200000 && sum < 250000){
      return 0.07
    }else if(sum>=250000 && sum < 300000){
      return 0.09
    }else if(sum>=300000 && sum < 350000){
      return 0.11
    }else if(sum>=350000 && sum < 400000){
      return 0.13
    }else{
      return 0.15
    }
  }

  const fetchclosedtripsbydate=async()=>{
    try{
    if(searchData7.start_date && searchData7.end_date){
      var data=await searchclosedTripsbyDate(searchData7.start_date, searchData7.end_date)
      const acctemp3=data.data.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Accepted")
      var acctemp=removeDuplicates(acctemp3, "trip_id")
      //data.data=data.data.filter(t=>t.trip_owner=="Aarju")
      for(let i=0;i<acctemp.length;i++){
        const data2=await fetchstatushistory(data.data[i].trip_id)
        //console.log(data2.data)
        for(let j=0;j<data2.data[0].status_history.length;j++){
          if(data2.data[0].status_history[j].new_status=="Converted"){
            data.data[i].conv_date=data2.data[0].status_history[j].date
            const conv_month=new Date(data2.data[0].status_history[j].date).getMonth()+1
            const conv_year=new Date(data2.data[0].status_history[j].date).getFullYear()
            const date=getmonth2(conv_month, conv_year)
            //console.log(date.startdate, date.enddate, data.data[i].trip_owner)
            const data3=await searchconvTripsbyDatenOwner(new Date(date.startdate), new Date(date.enddate), data.data[i].trip_owner)
            const acctemp2=data3.data.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales")
            var temp=removeDuplicates(acctemp2, "trip_id")
            //const temp=temp2.filter(t=>t.trip_owner=="Aarju")
           
            console.log(temp)
            let sum=0
            for(let k=0;k<temp.length;k++) {
              // if("cust_payments" in data3.data[k] && "supplier_payments" in data3.data[k])
              // const profittrip=total(temp[k].cust_payments) -
              // sptotal(temp[k].supplier_payments) -
              // gettaxes(temp[k]) -
              // gettcs(temp[k])
              // const a=total(temp[k].cust_payments) -sptotal(temp[k].supplier_payments)
              // const b=gettcs(temp[k])
              // const c=gettaxes(temp[k]) 
              
             const profittrip=getprofit(temp[k])
             var upsellprofit="upsell" in temp[k] && temp[k].upsell.length>0?upsellprofittotal(temp[k].upsell):0
             console.log("Upsell: "+ upsellprofit)
            //  if(data.data[i].trip_id==65267 || data.data[i].trip_id==95983){
            //   // console.log(total(temp[k].cust_payments),  sptotal(temp[k].supplier_payments), gettcs(temp[k]), gettaxes(temp[k]))
            //   //console.log(sptotal(temp[k].supplier_payments))
            //   console.log(a,b,c)
            //  }
              sum=sum+profittrip
            }
            console.log(acctemp[i].trip_id)
            console.log(acctemp[i].trip_owner)
            console.log(sum)
            data.data[i].sp_incentive_slab=getslab(sum)
          }
        }
      }
      //console.log(data.data)
      setlisttripData8(acctemp)
    }else{
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  }

  const getupsellrecord=async(req,res)=>{
    try{
      var temp=[]
      const data41=await getupsellprofit(new Date("2025-07-01"), new Date("2025-08-01"))
      const data42=await getupsellprofit(new Date("2025-08-01"), new Date("2025-09-01"))
      const data43=await getupsellprofit(new Date("2025-09-01"), new Date("2025-10-01"))
      const data44=await getupsellprofit(new Date("2025-10-01"), new Date("2025-11-01"))
      const data45=await getupsellprofit(new Date("2025-11-01"), new Date("2025-12-01"))
      const data46=await getupsellprofit(new Date("2025-12-01"), new Date("2026-01-01"))
      const data47=await getupsellprofit(new Date("2026-01-01"), new Date("2026-02-01"))
      const data48=await getupsellprofit(new Date("2026-02-01"), new Date("2026-03-01"))
      const data49=await getupsellprofit(new Date("2026-03-01"), new Date("2026-04-01"))
      const data50=await getupsellprofit(new Date("2026-04-01"), new Date("2026-05-01"))
      const data51=await getupsellprofit(new Date("2026-05-01"), new Date("2026-06-01"))
      const data52=await getupsellprofit(new Date("2026-06-01"), new Date("2026-07-01"))
      const data53=await getupsellprofit(new Date("2026-07-01"), new Date("2026-08-01"))
      const data54=await getupsellprofit(new Date("2026-08-01"), new Date("2026-09-01"))
      const data55=await getupsellprofit(new Date("2026-09-01"), new Date("2026-10-01"))
      const data56=await getupsellprofit(new Date("2026-10-01"), new Date("2026-11-01"))
      const data57=await getupsellprofit(new Date("2026-11-01"), new Date("2026-12-01"))
      const data58=await getupsellprofit(new Date("2026-12-01"), new Date("2027-01-01"))
      const data59=await getupsellprofit(new Date("2027-01-01"), new Date("2027-02-01"))
      const data60=await getupsellprofit(new Date("2027-02-01"), new Date("2027-03-01"))
      const data61=await getupsellprofit(new Date("2027-03-01"), new Date("2027-04-01"))
      const data62=await getupsellprofit(new Date("2027-04-01"), new Date("2027-05-01"))
      const data63=await getupsellprofit(new Date("2027-05-01"), new Date("2027-06-01"))
      const data64=await getupsellprofit(new Date("2027-06-01"), new Date("2027-07-01"))
      const data65=await getupsellprofit(new Date("2027-07-01"), new Date("2027-08-01"))
      const data66=await getupsellprofit(new Date("2027-08-01"), new Date("2027-09-01"))
      const data67=await getupsellprofit(new Date("2027-09-01"), new Date("2027-10-01"))
      const data68=await getupsellprofit(new Date("2027-10-01"), new Date("2027-11-01"))
      const data69=await getupsellprofit(new Date("2027-11-01"), new Date("2027-12-01"))
      const data70=await getupsellprofit(new Date("2027-12-01"), new Date("2028-01-01"))
      temp=[{
        month:7,
        year:2025,
        value:data41.data,
      },
      {
        month:8,
        year:2025,
        value:data42.data,
      },
      {
        month:9,
        year:2025,
        value:data43.data,
      },
      {
        month:10,
        year:2025,
        value:data44.data,
      },
      {
        month:11,
        year:2025,
        value:data45.data,
      },
        {
        month:12,
        year:2025,
        value:data46.data,
      },
       {
        month:1,
        year:2026,
        value:data47.data,
      },
       {
        month:2,
        year:2026,
        value:data48.data,
      },
       {
        month:3,
        year:2026,
        value:data49.data,
      },
       {
        month:4,
        year:2026,
        value:data50.data,
      },
       {
        month:5,
        year:2026,
        value:data51.data,
      },
       {
        month:6,
        year:2026,
        value:data52.data,
      },
       {
        month:7,
        year:2026,
        value:data53.data,
      },
       {
        month:8,
        year:2026,
        value:data54.data,
      },
       {
        month:9,
        year:2026,
        value:data55.data,
      },
       {
        month:10,
        year:2026,
        value:data56.data,
      },
       {
        month:11,
        year:2026,
        value:data57.data,
      },
       {
        month:12,
        year:2026,
        value:data58.data,
      },
    ]
    console.log(temp)
    return temp
    }catch(e){
      console.log(e)
    }
  }

  const fetchnewclosedtripsbydate=async()=>{
    try{
      setworking(true)
    if(searchData7.start_date && searchData7.end_date){
      var data=await searchclosedDABTripsbyDate(searchData7.start_date, searchData7.end_date)
      const acctemp3=data.data.filter(trip=>trip.trip_status=="Closed" && "booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state=="Accepted" || trip.trip_status=="Dropped After Booking")
      var acctemp=removeDuplicates(acctemp3, "trip_id")
      console.log(acctemp)
      const upsellr=await getupsellrecord()
      if(acctemp.length>0){
      for(let i=0;i<acctemp.length;i++){
        acctemp[i].conv_date=getconvdate(acctemp[i])
      }
      //figuring out the oldest converted date
      const minObj = acctemp.reduce((min, obj) => 
          new Date(obj.conv_date) < new Date(min.conv_date) ? obj : min
        );
      //console.log(minObj)
      //searching all bookings from oldest converted date
      var sd=DateCalc2(minObj.conv_date, -30)
      var ed=DateCalc2(searchData7.end_date,1)
      console.log(sd, ed)
      const data = await searchconvTripsbyDate(sd, ed); 
      console.log(data.data)

      for(let i=0;i<acctemp.length;i++){
        console.log(acctemp[i])
        var spincentivesum=0, tlincentivesum=0
        const convmonth=new Date(acctemp[i].conv_date).getUTCMonth()+1
        const convyear=new Date(acctemp[i].conv_date).getFullYear()
        console.log(convmonth, convyear)
        //figure out if there is mismatch in converted date
        const shconvmonth=new Date(acctemp[i].status_history.date).getUTCMonth()+1
        const shconvyear=new Date(acctemp[i].status_history.date).getFullYear()

        if(shconvmonth !==convmonth || shconvyear !==convyear){
          acctemp[i].error=true
        }else{
          acctemp[i].error=false
        }
        //calculate upsell incentive for trip id
         const up_conv_month=new Date(acctemp[i].trip_start_date).getMonth()+1
         const up_conv_year=new Date(acctemp[i].trip_start_date).getFullYear()
         var upselltemp=upsellr.filter(u=>u.month==up_conv_month && u.year==up_conv_year)
          var upsellincentiveslab=0
         if(upselltemp.length>0){
        // const up_date=getmonth2(up_conv_month, up_conv_year)
        // const data4=await getupsellprofit(new Date(up_date.startdate), new Date(up_date.enddate))
        // console.log(data4.data)
       
        if(upselltemp[0].value && upselltemp[0].value>50000 && upselltemp[0].value<100000){
          upsellincentiveslab=0.03
        }else if(upselltemp[0].value && upselltemp[0].value>=100000 && upselltemp[0].value<150000){
          upsellincentiveslab=0.05
        }else if(upselltemp[0].value && upselltemp[0].value>=150000){
          upsellincentiveslab=0.08
        }else{
          upsellincentiveslab=0
        }
        
        }
        acctemp[i].upsellincentiveslab=upsellincentiveslab
        //sp incentive
        // const test=data.data.filter(t=>t.trip_id==173181)
        // console.log(test)
        // console.log(getconvdate(test[0]))
        // console.log(new Date(getconvdate(test[0])))
        // console.log(new Date(getconvdate(test[0])).getUTCMonth()+1)
        // console.log(new Date(getconvdate(test[0])).getFullYear())
        const countabletrips2=data.data.filter(trip=>(trip.trip_owner==acctemp[i].trip_owner) && (convmonth==(new Date(getconvdate(trip)).getUTCMonth()+1)) && (convyear==(new Date(getconvdate(trip)).getFullYear())) && ("booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales"))
        //console.log(countabletrips2)
        var countabletrips=removeDuplicates(countabletrips2, "trip_id")
        console.log(countabletrips)
        if(countabletrips.length>0){
          for (let j=0;j<countabletrips.length;j++){
            if("upsell" in countabletrips[j] && countabletrips[j].upsell){
            spincentivesum=spincentivesum+getprofit(countabletrips[j])-upsellprofittotal(countabletrips[j].upsell)
            }else{
              spincentivesum=spincentivesum+getprofit(countabletrips[j])
            }
          }
        }else{
          spincentivesum=0
        }
        acctemp[i].spincentivesum=spincentivesum
        acctemp[i].sp_incentive_slab=getslab(spincentivesum)
        //calculate number of bookings amde by SP in month
        if(new Date(acctemp[i].conv_date).getTime()>new Date("2026-10-01").getTime() && checkserviceduration(acctemp[i].trip_owner,employeelist)>120){
          console.log(acctemp[i].trip_owner)
        const countabletrips3=data.data.filter(trip=>(trip.trip_owner==acctemp[i].trip_owner) && (convmonth==(new Date(getconvdate(trip)).getUTCMonth()+1)) && (convyear==(new Date(getconvdate(trip)).getFullYear())))
        var countabletrips4=removeDuplicates(countabletrips3, "trip_id")
        if(countabletrips4.length>7){
          acctemp[i].addreward=0.1
        }else if(countabletrips4.length<6){
          acctemp[i].addreward=-0.15
        }
      }else{
        acctemp[i].addreward=0
      }
        //console.log(spundertl)
        //TL calculation
        for(let k=0;k<spundertl.length;k++){
          if(acctemp[i].team_leader==spundertl[k].name){
              const tlcountabletrips2=data.data.filter(trip=>(trip.team_leader==spundertl[k].name) && (convmonth==(new Date(getconvdate(trip)).getMonth()+1)) && ("booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales") && (convyear==(new Date(getconvdate(trip)).getFullYear())))
              var tlcountabletrips=removeDuplicates(tlcountabletrips2, "trip_id")
              console.log(tlcountabletrips)
               if(tlcountabletrips.length>0){
          for (let j=0;j<tlcountabletrips.length;j++){
            tlincentivesum=tlincentivesum+getprofit(tlcountabletrips[j])-upsellprofittotal(tlcountabletrips[j].upsell)
          }
        }else{
          tlincentivesum=0
        }
        console.log(tlincentivesum)
        break
          }else{
            tlincentivesum=0
          }
        }
        acctemp[i].tlincentivesum=tlincentivesum
        var temp=spundertl.filter(data=>data.month==convmonth && data.year==convyear && data.name==acctemp[i].team_leader)
        console.log(temp)
        if(temp.length>0){
          if("old_value" in temp[0]){
              acctemp[i].tl_incentive_slab=temp[0].old_value
          }else{
              acctemp[i].tl_incentive_slab=gettlincentives(Number(tlincentivesum), Number(temp[0].number_sp), convyear)
          }
          
        }
        
    
      }
      console.log(acctemp)
      setlisttripData8(acctemp)
      }
      setexpanded7(true)
      setworking(false)
    }else{
      alert("Please enter a start date and an end date before search");
    }
  }catch(err){
    console.log(err)
  }
  }

  const fetchTripsbystartdate=async()=>{
    try{
    const data=await searchConvTripsbyStartDate(searchData8.start_date, searchData8.end_date)
    
  //  for(let i=0;i<data.data.length;i++){
  //   if("status_history" in data.data[i] && data.data[i].status_history.length>0){
  //     const temp=data.data[i].status_history.filter(sh=>sh.new_status=="Converted")
  //     if(temp.length>0){
  //       data.data[i].conv_date=temp[0].date
  //     }
  //     // if(i==1){
  //     //   console.log(temp)
  //     //   console.log(data.data[i])
  //     // }
  //   } 
    
  //  }
    console.log(data.data)
    setlisttripData10(data.data)
    setexpanded10(true)
  }catch(err){
    console.log(err)
  }
  }

  function convertToDaysCountArray(arr) {
  const counts = {};

  // Count occurrences
  arr.forEach(value => {
    counts[value] = (counts[value] || 0) + 1;
  });

  // Convert to desired array format
  return Object.entries(counts).map(([key, value]) => ({
    days: Number(key),
    count: value
  }));
  }


   const fetchTripsbystartdate2=async()=>{
    try{
    var finalobj=[]
    const data=await searchConvTripsbyStartDate(searchData10.start_date, searchData10.end_date)
    console.log(data.data)
    var temp=data.data.filter(trip=>"booking" in trip && "transfer_state" in trip.booking && trip.booking.transfer_state!=="Back to Sales" && !("on_hold" in trip && trip.on_hold))
    console.log(temp)
    if(temp.length>0){
      for(let i=0;i<temp.length;i++){
        var tot=total(temp[i].cust_payments)
        console.log(tot)
        var sum=0
        if(temp[i].cust_payments.length>0){
          for(let j=0;j<temp[i].cust_payments.length;j++){
            if(temp[i].cust_payments[j].status=="Received"){
            sum=sum+temp[i].cust_payments[j].amount
            }else if(temp[i].cust_payments[j].status=="Refund" || temp[i].cust_payments[j].status=="Credit Note"){
            sum=sum-temp[i].cust_payments[j].amount
            }
            console.log(sum)
            if(sum==tot){
              var gap=Math.round((new Date(temp[i].trip_start_date).getTime()-new Date(temp[i].cust_payments[j].date).getTime())/(1000*60*60*24))
              if(gap<0){
                gap=Math.round((new Date(temp[i].trip_start_date).getTime()-new Date(temp[i].cust_payments[j-1].date).getTime())/(1000*60*60*24))
              }
              finalobj=[...finalobj, gap]
            }
          }
        }
      }
      console.log(finalobj)
      //setlisttripData11(convertToDaysCountArray(finalobj))
      setlisttripData11([...convertToDaysCountArray(finalobj),{days:"Total", count:temp.length}])
      setexpanded12(true)
    }else{
      setlisttripData11([])
    }
    
  }catch(err){
    console.log(err)
  }
  }

  const getbioid=(owner)=>{
    const data=emp.filter(e=>e.short_name==owner)
    if(data.length>0 && "biometric_id" in data[0]){
      return data[0].biometric_id
    }else{
      return ""
    }
  }

  const getcount=(cat)=>{
    //const categories = ["Tour", "Hotel", "Insurance", "Arrival Card", "SIM", "Flight Fare", "Flight Ancilliary", "Others"];
    var temp=[...listtripData6]
    if(cat=="TOUR" || cat=="HOTEL"){
      temp=listtripData6.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
      
    }
    if(cat=="FLIGHT FARE" || cat=="FLIGHT ANCILLIARY"){
      temp=listtripData6.filter(t=>t.flight_cp>0 && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
      
    }
    if(cat=="INSURANCE"){
      temp=listtripData6.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("complementary_insurance" in t && t.complementary_insurance))
      
    }
    if(cat=="SIM"){
      temp=listtripData6.filter(t=>identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("complementary_sim" in t && t.complementary_sim))
      
    }
    if(cat=="VISA"){
      temp=listtripData6.filter(t=>(t.primary_destination=="Indonesia") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales"))
      
    }
    if(cat=="ARRIVAL CARD"){
      temp=listtripData6.filter(t=>(t.primary_destination=="Indonesia" ||t.primary_destination=="Thailand" || t.primary_destination=="Singapore" || t.primary_destination=="Malaysia" ||t.primary_destination=="Vietnam") && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") && !("complementary_ac" in t && t.complementary_ac))
      
    }
    if(cat=="FOREX CARD" || cat=="FOREX CASH"){
        temp=listtripData6.filter(t=>t.land_cp>0 && identifydest(t.primary_destination) && ("booking" in t && "transfer_state" in t.booking && t.booking.transfer_state!=="Back to Sales") )
    }

    return temp.length
  }

  const getpitchcount=(cat)=>{
    //const categories = ["Tour", "Hotel", "Insurance", "Arrival Card", "SIM", "Flight Fare", "Flight Ancilliary", "Others", "Forex Cash", "Forex Card", "Visa"];
    var temp=[...listtripData6]
    
     if(cat=="HOTEL"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.hotel)
      
    }
    if(cat=="TOUR"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.tour)
      
    }
    if(cat=="SIM"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.sim)
      
    }
    if(cat=="FLIGHT FARE" || cat=="FLIGHT ANCILLIARY"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.flight)
      
    }
    if(cat=="INSURANCE"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.insurance)
      
    }
    if(cat=="VISA"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.visa)
      
    }
    if(cat=="ARRIVAL CARD"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.ac)
      
    }
     if(cat=="FOREX CARD" || cat=="FOREX CASH"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.forex)
      
    }
    if(cat=="OTHERS"){
      temp=temp.filter(t=>"upsell_pitch" in t && t.upsell_pitch.others)
      
    }
   
    return temp.length
  }

  const tlincentive=(trip)=>{
    if(trip && "tl_incentive_slab" in trip){
      return (trip.tl_incentive_slab*(getprofit(trip)-("upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0))).toFixed(1)
  }else{
    return 0
  }
  }
  const managername=(trip)=>{
    if(trip && "team_leader" in trip && trip.team_leader){
      return getmanager(trip.team_leader, trip.converted_date)
    }else{
      return ""
    }
  }

  const datalistdisplay11 = listtripData10.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData10.indexOf(trip),
    trip_owner: trip.trip_owner,
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    pan:trip.pan,
    invoice_name:trip.invoice_name,
  })); 

  const datalistdisplay12=listtripData11.map(data=>({
    id:listtripData11.indexOf(data),
    days:data.days,
    count:data.count,
  }))

  //Incentive Calc
  const datalistdisplay8b = listtripData8.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData8.indexOf(trip),
    trip_owner: trip.trip_owner,
    revenue: trip.cust_payments ? total(trip.cust_payments) : 0,
    tl: trip.team_leader,
    manager:managername(trip),
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    conv_date:trip.conv_date,
    trip_status:trip.trip_status,
    tl_incentive:tlincentive(trip),
    manager_incentive:tlincentive(trip)*.5,
    sp_incentive_slab:Math.round(trip.sp_incentive_slab*100),
    tl_incentive_slab:(trip.tl_incentive_slab*100).toFixed(1),
    upsell_incentive_slab:"upsell" in trip?Math.round(trip.upsellincentiveslab*100):"",
    upsell_incentive:"upsell" in trip?Math.round(trip.upsellincentiveslab*upsellprofittotal(trip.upsell)):"",
    upsell_profit: "upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0,
    ops_name:"booking" in trip?trip.booking.ops_assigned:"",
    error:trip.error,
    biometric_id:trip && "trip_owner" in trip?getbioid(trip.trip_owner):"",
    cx_incentive:"",
    spincentivesum:trip.spincentivesum,
    addreward:trip.addreward,
    tlincentivesum:trip.tlincentivesum,
    closed_date:"status_history" in trip?trip.status_history.date:"",
    incentive_paid:"incentive_paid" in trip?trip.incentive_paid:"",
    profit:profitwithoutupsell(trip),
    sp_incentive:Math.round((profitwithoutupsell(trip))*trip.sp_incentive_slab*(1+trip.addreward)),
    flight_profit: getflightprofit(trip),
    land_profit:getprofit(trip)-("flight_sp" in trip && "flight_cp" in trip?(trip.flight_sp-trip.flight_cp):0)-("upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0),
    sales_incentive_new:"converted_date" in trip && new Date(trip.converted_date).getTime()>new Date("2026-05-01").getTime()?Math.round((profitwithoutupsell(trip))*trip.sp_incentive_slab)*0.9*(1+trip.addreward):"",
    ops_incentive_new:"converted_date" in trip && new Date(trip.converted_date).getTime()>new Date("2026-05-01").getTime()?Math.round((profitwithoutupsell(trip))*trip.sp_incentive_slab*0.05*((profitwithoutupsell(trip)-getflightprofit(trip))/profitwithoutupsell(trip))):"",
    flight_incentive_new:"converted_date" in trip && new Date(trip.converted_date).getTime()>new Date("2026-05-01").getTime()?Math.round((profitwithoutupsell(trip))*trip.sp_incentive_slab*0.1*(getflightprofit(trip)/profitwithoutupsell(trip))):"",
  })); 

   const datalistdisplay8 = listtripData8.map((trip) => ({
    trip_id: trip.trip_id,
    id: listtripData8.indexOf(trip),
    trip_owner: trip.trip_owner,
    revenue: trip.cust_payments ? total(trip.cust_payments) : 0,
    tl: trip.team_leader,
    manager:"team_leader" in trip && trip.team_leader?getmanager(trip.team_leader, trip.converted_date):"", 
    name: trip.cust_name,
    dest:trip.primary_destination,
    trip_start_date: trip.trip_start_date,
    conv_date:trip.conv_date,
    tl_incentive:trip.tl_incentive,
    spincentivesum:trip.spincentivesum,
    tlincentivesum:trip.tlincentivesum,
    sp_incentive_slab:Math.round(trip.sp_incentive_slab*100),
    tl_incentive_slab:Math.round(trip.tl_incentive_slab*100),
    upsell_incentive_slab:"upsell" in trip?Math.round(trip.upsellincentiveslab*100):"",
    upsell_incentive:"upsell" in trip?Math.round(trip.upsellincentiveslab*upsellprofittotal(trip.upsell)):"",
    upsell_profit: "upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0,
    ops_name:"booking" in trip?trip.booking.ops_assigned:"",
    biometric_id:trip && "trip_owner" in trip?getbioid(trip.trip_owner):"",
    ops_incentive:"trip_review_score" in trip?(trip.trip_review_score==5?(Math.round(0.01*(("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)))):0):"",
    //tl_incentive:"tl_incentive" in trip?trip.tl_incentive:"",
    incentive_paid:"incentive_paid" in trip?trip.incentive_paid:"",
   profit:("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)-("upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0),
    sp_incentive:Math.round((("cust_payments" in trip && "supplier_payments" in trip
    ? total(trip.cust_payments) -
      sptotal(trip.supplier_payments) -
      gettaxes(trip) -
      gettcs(trip)
    : 0)-("upsell" in trip && trip.upsell.length>0?upsellprofittotal(trip.upsell):0))*trip.sp_incentive_slab),
  }));

   const datalistdisplay19 = listtripData18.map((trip) => ({
    date: trip.date,
    id: listtripData18.indexOf(trip),
    count:trip.count,
   
  }));

   const datalistdisplay20 = listtripData19.map((trip) => ({
    date: "day" in trip?trip.day.date:"",
    id: listtripData19.indexOf(trip),
    trip_id:trip.trip_id,
    tour_name:"day" in trip?trip.day.tour_name:"",
    name:trip.cust_name,
    dest:trip.primary_destination,
  }));

  const datalistdisplay28 = listtripData28.map((trip) => ({
    id: listtripData28.indexOf(trip),
    trip_id:trip.trip_id,
    trip_owner:trip.trip_owner,
    ops_owner:trip.booking.ops_assigned,
    entity:trip.changelog.entity,
    changed_by:trip.changelog.changed_by,
    old_value: trip.changelog.old_value,
    new_value:trip.changelog.new_value,
    old_profit:trip.changelog.old_profit,
    new_profit:trip.changelog.new_profit,
    gap:"new_profit" in trip.changelog && "old_profit" in trip.changelog?trip.changelog.new_profit-trip.changelog.old_profit:""
  }));

  const datalistdisplay15=upsellcat.map((trip) => ({
    count: trip.tripCount,
    id: upsellcat.indexOf(trip),
    share:(trip.tripCount/getcount(trip.category)).toFixed(2),
    valid_trips:getcount(trip.category),
    sales:trip.totalSales,
    pitch:getpitchcount(trip.category),
    pitch_share:(getpitchcount(trip.category)/getcount(trip.category)).toFixed(2),
    total_share:(trip.tripCount/getpitchcount(trip.category)).toFixed(2),
    profit:trip.profit,
    profit_perc:(trip.profit/trip.totalSales).toFixed(2),
    category:trip.category,
  }));

  const getprofitgapb2s=()=>{
    if(datalistdisplay2.length>1){
    const b2sdata=datalistdisplay2.filter(t=>t.ops_status=="Back to Sales")
    const sum=b2sdata.reduce((sum, a)=>{return sum=sum+(a.profit-a.month_end_profit)},0)
    return sum
    }else{
      return 0
    }
  }

  const getprofitgapnonb2s=()=>{
    if(datalistdisplay2.length>1){
    const b2sdata=datalistdisplay2.filter(t=>t.ops_status!=="Back to Sales")
    const sum=b2sdata.reduce((sum, a)=>{return sum=sum+(a.profit-a.month_end_profit)},0)
    return sum
    }else{
      return 0
    }
  }
  
  //console.log(datalistdisplay19)
  return (
    <div>
    {(role=="Admin" || role=="TL" || role=="SME" || role=="Support" || role=="Manager" || role=="Accounts" || role=="Marketing" || role=="Operations" || role=="Operations-TL" || role=="Product")?(<div>
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          centered
        >
          <Tab label="SP wise" {...a11yProps(0)} />
          {/* <Tab label="Hitesh" {...a11yProps(1)} />
          
          <Tab label="Sidharth" {...a11yProps(2)} />
          <Tab label="Yadvinder" {...a11yProps(3)} />
          <Tab label="HarshB" {...a11yProps(4)} />
          <Tab label="Tarun" {...a11yProps(5)} />
          <Tab label="NitinK" {...a11yProps(6)} />
          <Tab label="Rana" {...a11yProps(7)} />
          <Tab label="Qausain" {...a11yProps(8)} /> */}
          <Tab label="Dest wise" {...a11yProps(1)} />
          {/* <Tab label="Sightseeing Descriptions" {...a11yProps(2)} /> */}
        </Tabs>
      </Box>
      <TabPanel value={value} index={1}>
        <Paper variant="outlined" className={classes.paper}>
          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Destination level
          </Typography>

          <div align="center">
            <TextField
              variant="outlined"
              type="date"
              label="Converted On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData4({ ...searchData4, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Converted On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData4({ ...searchData4, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getconvTrips(searchData4.start_date, searchData4.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <div align="center">
          {role=="Admin"?"Ops cost includes cost of sp salary+incentives+salaries of TLs and M+salary cost of ops team":""}
          </div>
          <br></br>
          <div>
            {datalistdisplay5.length > 0 ? (
              <div style={{ height: 1800, width: "100%" }}>
                <DataGrid
                  rows={datalistdisplay5}
                  columns={columns5}
                  autoPageSize
                  // pageSize={40}
                  // autoHeight
                ></DataGrid>
              </div>
            ) : (
              <div align="center">
                <h1>No data found</h1>
              </div>
            )}
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={2}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  preventDoubleClick(getTripsbyTL(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl1}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    autoPageSize
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={0}>
      <FormControlLabel control={ <Switch  onChange={handleChange2} color="secondary" label="Search all"/>} label="Search Ex" />
      <FormControlLabel control={ <Switch  onChange={handleChange3} color="primary" label="B2S"/>} label="Search B2S" />
     
        {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Top 3 (by PAT): Harsh 730k, Mitanshu 700k, Rishi 686k|| Top 3 (by
              #): Aryan 21, Hitesh 19, Palashika 17
            </Typography>
           
            <div align="center">
           
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value, type:"Multiple" })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value, type:"Multiple" })
                }
              />
             
              <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="month">Month</InputLabel>
              <Select
                classname={classes.textField}
                labelId="month"
                variant="outlined"
                value={searchData.month}
                onChange={(e) => changemonth(e.target.value)}
              >
                <MenuItem value={"January 2023"}>January 2023</MenuItem>
                <MenuItem value={"February 2023"}>February 2023</MenuItem>
                <MenuItem value={"March 2023"}>March 2023</MenuItem>
                <MenuItem value={"April 2023"}>April 2023</MenuItem>
                <MenuItem value={"May 2023"}>May 2023</MenuItem>
                <MenuItem value={"June 2023"}>June 2023</MenuItem>
                <MenuItem value={"July 2023"}>July 2023</MenuItem>
                <MenuItem value={"August 2023"}>August 2023</MenuItem>
                <MenuItem value={"September 2023"}>September 2023</MenuItem>
                <MenuItem value={"October 2023"}>October 2023</MenuItem>
                <MenuItem value={"November 2023"}>November 2023</MenuItem>
                <MenuItem value={"December 2023"}>December 2023</MenuItem>
                <MenuItem value={"January 2024"}>January 2024</MenuItem>
                <MenuItem value={"February 2024"}>February 2024</MenuItem>
                <MenuItem value={"March 2024"}>March 2024</MenuItem>
                <MenuItem value={"April 2024"}>April 2024</MenuItem>
                <MenuItem value={"May 2024"}>May 2024</MenuItem>
                <MenuItem value={"June 2024"}>June 2024</MenuItem>
                <MenuItem value={"July 2024"}>July 2024</MenuItem>
                <MenuItem value={"August 2024"}>August 2024</MenuItem>
                <MenuItem value={"September 2024"}>September 2024</MenuItem>
                <MenuItem value={"October 2024"}>October 2024</MenuItem>
                <MenuItem value={"November 2024"}>November 2024</MenuItem>
                <MenuItem value={"December 2024"}>December 2024</MenuItem>
                <MenuItem value={"January 2025"}>January 2025</MenuItem>
                <MenuItem value={"February 2025"}>February 2025</MenuItem>
                <MenuItem value={"March 2025"}>March 2025</MenuItem>
                <MenuItem value={"April 2025"}>April 2025</MenuItem>
                <MenuItem value={"May 2025"}>May 2025</MenuItem>
                <MenuItem value={"June 2025"}>June 2025</MenuItem>
                <MenuItem value={"July 2025"}>July 2025</MenuItem>
                <MenuItem value={"August 2025"}>August 2025</MenuItem>
                <MenuItem value={"September 2025"}>September 2025</MenuItem>
                <MenuItem value={"October 2025"}>October 2025</MenuItem>
                <MenuItem value={"November 2025"}>November 2025</MenuItem>
                <MenuItem value={"December 2025"}>December 2025</MenuItem>
                <MenuItem value={"January 2026"}>January 2026</MenuItem>
                                <MenuItem value={"February 2026"}>February 2026</MenuItem>
                                <MenuItem value={"March 2026"}>March 2026</MenuItem>
                                <MenuItem value={"April 2026"}>April 2026</MenuItem>
                                <MenuItem value={"May 2026"}>May 2026</MenuItem>
                                <MenuItem value={"June 2026"}>June 2026</MenuItem>
                                <MenuItem value={"July 2026"}>July 2026</MenuItem>
                                <MenuItem value={"August 2026"}>August 2026</MenuItem>
                                <MenuItem value={"September 2026"}>September 2026</MenuItem>
                                <MenuItem value={"October 2026"}>October 2026</MenuItem>
                                <MenuItem value={"November 2026"}>November 2026</MenuItem>
                                <MenuItem value={"December 2026"}>December 2026</MenuItem>
                                <MenuItem value={"January 2027"}>January 2027</MenuItem>
                                <MenuItem value={"February 2027"}>February 2027</MenuItem>
                                <MenuItem value={"March 2027"}>March 2027</MenuItem>
                                <MenuItem value={"April 2027"}>April 2027</MenuItem>
                                <MenuItem value={"May 2027"}>May 2027</MenuItem>
                                <MenuItem value={"June 2027"}>June 2027</MenuItem>
                                <MenuItem value={"July 2027"}>July 2027</MenuItem>
                                <MenuItem value={"August 2027"}>August 2027</MenuItem>
                                <MenuItem value={"September 2027"}>September 2027</MenuItem>
                                <MenuItem value={"October 2027"}>October 2027</MenuItem>
                                <MenuItem value={"November 2027"}>November 2027</MenuItem>
                                <MenuItem value={"December 2027"}>December 2027</MenuItem>
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="destination">Destination</InputLabel>
              <Select
                classname={classes.textField}
                labelId="destination"
                variant="outlined"
                value={searchData.destination}
                onChange={(e) => setsearchData({...searchData, destination:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                {dest.map((dest) => {
                return <MenuItem value={dest}>{dest}</MenuItem>;
              })}
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="category">Category</InputLabel>
              <Select
                classname={classes.textField}
                labelId="category"
                variant="outlined"
                value={searchData.category}
                onChange={(e) => setsearchData({...searchData, category:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
               
              </Select>
              
            </FormControl>
             <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="tl">TL</InputLabel>
              <Select
                classname={classes.textField}
                labelId="tl"
                variant="outlined"
                value={searchData.tl}
                onChange={(e) => setsearchData({...searchData, tl:e.target.value})}
              >
              <MenuItem value={""}>Clear</MenuItem>
              {emptl.map(emp=>
             
                <MenuItem value={emp.short_name}>{emp.short_name}</MenuItem>
              )}
                
               
               
              </Select>
              
            </FormControl>
            <Button
                onClick={() =>
                  preventDoubleClick(getconvTrips(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <Button
                onClick={() =>
                  preventDoubleClick(newgetconvTrips(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Short Search
              </Button>
              <Button
                onClick={() =>
                  preventDoubleClick(b2savoidance())
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                B2S Avoidance
              </Button>
              {cuser=="Debayan"?(
              <Button
                onClick={() =>
                  preventDoubleClick(getconvTrips2(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                No Tax Search
              </Button>
              ):("")}
              {cuser=="Debayan"?(<Button
                onClick={() =>
                  showlandvalue()
                }
                color="primary"
                variant="contained"
                className={classes.button}
              >
                Land Value
              </Button>):("")}
              {cuser=="Debayan" && (datalistdisplayall2.length>1 || datalistdisplay2.length>1)?(<Button
                onClick={() =>
                  freezemonthendprofit()
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Month End Profit
              </Button>):("")}
              {cuser=="Debayan"?(<Button
                onClick={() =>
                  showrp()
                }
                color="primary"
                variant="contained"
                className={classes.button}
              >
                R & P
              </Button>):("")}
              <div>
              <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="tcs_mail">TCS Mail</InputLabel>
              <Select
                classname={classes.textField}
                labelId="tcs_mail"
                variant="outlined"
                value={searchData.tcs_mail}
                onChange={(e) => setsearchData({...searchData, tcs_mail:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="product">Product Check</InputLabel>
              <Select
                classname={classes.textField}
                labelId="product"
                variant="outlined"
                value={searchData.product_check}
                onChange={(e) => setsearchData({...searchData, product_check:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
              </Select>
              
            </FormControl>
             <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="reactivate">Reactivate</InputLabel>
              <Select
                classname={classes.textField}
                labelId="reactivate"            
                variant="outlined"
                value={searchData.reactivate}
                onChange={(e) => setsearchData({...searchData, reactivate:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={1}>1</MenuItem>
              </Select>
              
            </FormControl>
            <FormControl
              style={{
                minWidth: 120,
                marginTop: 16,
                marginRight: 32,
                marginLeft: 32,
              }}
            >
              <InputLabel id="ops_status">Ops Status</InputLabel>
              <Select
                classname={classes.textField}
                labelId="ops_status"
                variant="outlined"
                value={searchData.ops_status}
                onChange={(e) => setsearchData({...searchData, ops_status:e.target.value})}
              >
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Just Converted"}>Just Converted</MenuItem>
                <MenuItem value={"Requested"}>Requested</MenuItem>
                <MenuItem value={"Accepted"}>Accepted</MenuItem>
                <MenuItem value={"Back to Sales"}>Back to Sales</MenuItem>
                <MenuItem value={"Rejected"}>Rejected</MenuItem>
              </Select>
              
            </FormControl>
              </div>
          
              <h2>All</h2>
              {datalistdisplay.length>0 || datalistdisplayall.length>0?(<div>
              {(role=="Admin" || role=="Accounts") && datalistdisplay.length>0?(<div>
                   <CSVLink data={datalistdisplay} headers={headers3}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {datalistdisplay.length > 0 ? (
                <div style={{ height: (datalistdisplay.length*70>800?datalistdisplay.length*70:800), width: "100%" }}>
                  <DataGrid
                    rows={searchbyid?datalistdisplayall:datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={20}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length>0?<p>{"B2S: "+getprofitgapb2s()+" || Non B2S: "+getprofitgapnonb2s()+" || Total: "+(getprofitgapb2s()+getprofitgapnonb2s())}</p>:""}
              {datalistdisplay2.length>0?(<div>
                   <CSVLink data={searchbyid?datalistdisplayall2:datalistdisplay2} headers={headers}>Download CSV</CSVLink>
                   </div>
                ):("")}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={searchbyid?datalistdisplayall2:datalistdisplay2}
                    columns={columns4}
                    autoPageSize
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              </div>):("")}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
             <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Received Date (Total:{getSumByKey2(datalistdisplay3, "amount")})
                    </Typography>
                    <Button
                      expand={expanded6}
                      onClick={()=>setexpanded6(!expanded6)}
                      aria-expanded={expanded6}
                      aria-label="show more"
                    >
                      {expanded6?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
                    
            <FormControlLabel control={<Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" />} label="Final Installment Only"/>
            <TextField
              variant="outlined"
              type="date"
              label="Received On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData2({ ...searchData2, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Received On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData2({ ...searchData2, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbyreceipt(searchData2.start_date, searchData2.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded6} timeout="auto" unmountOnExit>
          {datalistdisplay3.length>0?(<div>
                   <CSVLink data={datalistdisplay3} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
          {datalistdisplay3.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay3}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                columns={columns2}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Customer Refund
                    </Typography>
                    <Button
                      expand={expanded1}
                      onClick={()=>setexpanded1(!expanded1)}
                      aria-expanded={expanded1}
                      aria-label="show more"
                    >
                      {expanded1?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            {/* <Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" label="Final Installment Only"/> */}
            <TextField
              variant="outlined"
              type="date"
              label="Refund On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Refund On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbyrefund(searchData6.start_date, searchData6.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded1} timeout="auto" unmountOnExit>
          {datalistdisplay7.length>0?(<div>
                   <CSVLink data={datalistdisplay7} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
          {datalistdisplay7.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay7}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                columns={columns2}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
           <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Payable Date (Total:{getSumByKey2(datalistdisplay4, "amount")})
                    </Typography>
                    <Button
                      expand={expanded4}
                      onClick={()=>setexpanded4(!expanded4)}
                      aria-expanded={expanded4}
                      aria-label="show more"
                    >
                      {expanded4?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
                     <FormControlLabel control={<Switch  onChange={()=>setsearchbypending(!searchbypending)} color="secondary" />} label="Search by Pending" />
                     <FormControlLabel control={<Switch  onChange={()=>setsearchbyinternalteam(!searchbyinternalteam)} color="secondary" />} label="Search by Internal" />
            <TextField
              variant="outlined"
              type="date"
              label="Paid On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData3({ ...searchData3, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Paid On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData3({ ...searchData3, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                getTripsbypaid(searchData3.start_date, searchData3.end_date)
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded4} timeout="auto" unmountOnExit>
          {datalistdisplay4.length>0?(<div>
                   <CSVLink data={datalistdisplay4} headers={headers4}>Download CSV</CSVLink>
                   </div>
                ):("")}
          {datalistdisplay4.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay4}
                columns={columns3}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
           <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Supplier Refund (Refund Due Sum:{sumrefundue})
                    </Typography>
                    <Button
                      expand={expanded3}
                      onClick={()=>setexpanded3(!expanded3)}
                      aria-expanded={expanded3}
                      aria-label="show more"
                    >
                      {expanded3?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            {/* <Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" label="Final Installment Only"/> */}
            <TextField
              variant="outlined"
              type="date"
              label="Refund On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Refund On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbysupplierrefund(searchData6.start_date, searchData6.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
            <Collapse in={expanded3} timeout="auto" unmountOnExit>
          {datalistdisplay9.length>0?(<div>
                   <CSVLink data={datalistdisplay9} headers={headers2}>Download CSV</CSVLink>
                   </div>
                ):("")}
          {datalistdisplay9.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay9}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                columns={columns2}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
           <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Start Date (Total Upsell Value: {getSumByKey2(datalistdisplay6, "upsell_value")} || Total Upsell Profit: {Math.round(getSumByKey2(datalistdisplay6, "upsell_profit"))}) || Total Hotel Upsell Profit: {Math.round(getSumByKey2(datalistdisplay6b, "upsell_profit"))}) 
                    </Typography>
                    <Button
                      expand={expanded2}
                      onClick={()=>setexpanded2(!expanded2)}
                      aria-expanded={expanded2}
                      aria-label="show more"
                    >
                      {expanded2?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
          
            <TextField
              variant="outlined"
              type="date"
              label="Start Date On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData5({ ...searchData5, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start Date On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData5({ ...searchData5, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbystartdate())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded2} timeout="auto" unmountOnExit>
          <div align="center">
            <FormControl
                                       style={{
                                         minWidth: 240,
                                         marginTop: 16,
                                         marginRight: 32,
                                         marginLeft: 8,
                                       }}
                                     >
                                       <InputLabel id="inventory">Inventory</InputLabel>
                                       <Select
                                         displayEmpty
                                         
                                         classname={classes.textField}
                                         labelId="inventory"
                                         onChange={(e) =>
                setsearchData5({ ...searchData5, inventory: e.target.value })
              }
                                       >
                                        <MenuItem value={false}>Clear</MenuItem>
                                       <MenuItem value={"Tour"}>Tour</MenuItem>
                                       <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                       <MenuItem value={"Insurance"}>Insurance</MenuItem>
                                       <MenuItem value={"Arrival Card"}>Arrival Card</MenuItem>
                                       <MenuItem value={"SIM"}>SIM</MenuItem>
                                       <MenuItem value={"Visa"}>Visa</MenuItem>
                                       <MenuItem value={"Flight Fare"}>Flight Fare</MenuItem> 
                                       <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> 
                                       <MenuItem value={"Forex Card"}>Forex Card</MenuItem> 
                                       <MenuItem value={"Forex Cash"}>Forex Cash</MenuItem> 
                                       <MenuItem value={"Others"}>Others</MenuItem> 
                                       </Select>
                                     </FormControl>
                                       <FormControl
                                       style={{
                                         minWidth: 240,
                                         marginTop: 16,
                                         marginRight: 32,
                                         marginLeft: 8,
                                       }}
                                     >
                                       <InputLabel id="pitch">Pitch</InputLabel>
                                       <Select
                                         displayEmpty
                                         value={searchData5.pitch}
                                         classname={classes.textField}
                                         labelId="pitch"
                                         onChange={(e) =>
                setsearchData5({ ...searchData5, pitch: e.target.value, eligible:false, eligiblenopitch:false })
              }
                                       >
                                        <MenuItem value={false}>Clear</MenuItem>
                                       <MenuItem value={"Tour"}>Tour</MenuItem>
                                       <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                       <MenuItem value={"Insurance"}>Insurance</MenuItem>
                                       <MenuItem value={"Arrival Card"}>Arrival Card</MenuItem>
                                       <MenuItem value={"SIM"}>SIM</MenuItem>
                                       <MenuItem value={"Visa"}>Visa</MenuItem>
                                       <MenuItem value={"Flight Fare"}>Flight Fare</MenuItem> 
                                       <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> 
                                       <MenuItem value={"Forex Card"}>Forex Card</MenuItem> 
                                       <MenuItem value={"Forex Cash"}>Forex Cash</MenuItem> 
                                       <MenuItem value={"Others"}>Others</MenuItem> 
                                       </Select>
                                     </FormControl>
                                      <FormControl
                                       style={{
                                         minWidth: 240,
                                         marginTop: 16,
                                         marginRight: 32,
                                         marginLeft: 8,
                                       }}
                                     >
                                       <InputLabel id="eligible">Eligible</InputLabel>
                                       <Select
                                         displayEmpty
                                          value={searchData5.eligible}
                                         classname={classes.textField}
                                         labelId="eligible"
                                         onChange={(e) =>
                setsearchData5({ ...searchData5, eligible: e.target.value, pitch:false, eligiblenopitch:false})
              }
                                       >
                                        <MenuItem value={false}>Clear</MenuItem>
                                       <MenuItem value={"Tour"}>Tour</MenuItem>
                                       <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                       <MenuItem value={"Insurance"}>Insurance</MenuItem>
                                       <MenuItem value={"Arrival Card"}>Arrival Card</MenuItem>
                                       <MenuItem value={"SIM"}>SIM</MenuItem>
                                       <MenuItem value={"Visa"}>Visa</MenuItem>
                                       <MenuItem value={"Flight Fare"}>Flight Fare</MenuItem> 
                                       <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> 
                                       <MenuItem value={"Forex Card"}>Forex Card</MenuItem> 
                                       <MenuItem value={"Forex Cash"}>Forex Cash</MenuItem> 
                                       <MenuItem value={"Others"}>Others</MenuItem> 
                                       </Select>
                                     </FormControl>
                                        <FormControl
                                       style={{
                                         minWidth: 240,
                                         marginTop: 16,
                                         marginRight: 32,
                                         marginLeft: 8,
                                       }}
                                     >
                                       <InputLabel id="eligiblenopitch">Eligible but not pitched</InputLabel>
                                       <Select
                                         displayEmpty
                                          value={searchData5.eligiblenopitch}
                                         classname={classes.textField}
                                         labelId="eligiblenopitch"
                                         onChange={(e) =>
                setsearchData5({ ...searchData5, eligiblenopitch: e.target.value, pitch:false, eligible:false })
              }
                                       >
                                        <MenuItem value={false}>Clear</MenuItem>
                                       <MenuItem value={"Tour"}>Tour</MenuItem>
                                       <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                       <MenuItem value={"Insurance"}>Insurance</MenuItem>
                                       <MenuItem value={"Arrival Card"}>Arrival Card</MenuItem>
                                       <MenuItem value={"SIM"}>SIM</MenuItem>
                                       <MenuItem value={"Visa"}>Visa</MenuItem>
                                       <MenuItem value={"Flight Fare"}>Flight Fare</MenuItem> 
                                       <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> 
                                       <MenuItem value={"Forex Card"}>Forex Card</MenuItem> 
                                       <MenuItem value={"Forex Cash"}>Forex Cash</MenuItem> 
                                       <MenuItem value={"Others"}>Others</MenuItem> 
                                       </Select>
                                     </FormControl>
          {datalistdisplay6.length>1?(<div>
                   <CSVLink data={datalistdisplay6} headers={headers6}>Download CSV</CSVLink>
                 
                   </div>
                ):("")}
          </div>
         
          {datalistdisplay6.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay6}
                columns={columns6}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
           <div align="center">
          {datalistdisplay15.length>1?(<div>
                   <CSVLink data={datalistdisplay15} headers={headers15}>Download CSV</CSVLink>
                   </div>):("")}</div>
          {datalistdisplay15.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay15}
                columns={columns15}
                
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
           {datalistdisplay6b.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay6b}
                columns={columns6}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}

          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
            <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Ops Profit
                    </Typography>
                    <Button
                      expand={expanded5}
                      onClick={()=>setexpanded5(!expanded5)}
                      aria-expanded={expanded5}
                      aria-label="show more"
                    >
                      {expanded5?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            <TextField
              variant="outlined"
              type="date"
              label="Conv Date On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData9({ ...searchData9, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Conv Date On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData9({ ...searchData9, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsforprofitdiff())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
            <Typography>Sum of Diff:{sumdiff} || Without flight: {sumdiff2}|| Loss due to B2S: {profitloss}</Typography>
          </div>
          <Collapse in={expanded5} timeout="auto" unmountOnExit>
          <div align="center">
         
          </div>
          {datalistdisplay10.length>1?(<div>
                   <CSVLink data={datalistdisplay10} headers={headers10}>Download CSV</CSVLink>
                   </div>
                ):("")}
          {datalistdisplay10.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay10}
                columns={columns12}
                onCellDoubleClick={(getValue) =>
                  gridcellclick(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        {role=="Admin" || role=="Accounts"?(
          <div>
        <Paper variant="outlined" className={classes.paper}>
        <div align="center">
          <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Change Log
            </Typography>
            <TextField
              variant="outlined"
              type="date"
              label="Changed On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData7({ ...searchData7, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Changed On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData7({ ...searchData7, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getbychangelog(searchData7.start_date, searchData7.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
                     </div>
          <div align="center">
          {datalistdisplay28.length>1?(<div>
                   <CSVLink data={datalistdisplay28} headers={headers18}>Download CSV</CSVLink>
                   </div>
                ):("")}
          </div>
         
          {datalistdisplay28.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay28}
                columns={columns18}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                autoPageSize
           
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
        </Paper>
          <Paper variant="outlined" className={classes.paper}>
        <div align="center">
              <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      New Incentive Calculation
                    </Typography>
                    <Button
                      expand={expanded7}
                      onClick={()=>setexpanded7(!expanded7)}
                      aria-expanded={expanded7}
                      aria-label="show more"
                    >
                      {expanded5?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            <TextField
              variant="outlined"
              type="date"
              label="Closed On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData7({ ...searchData7, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Closed On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData7({ ...searchData7, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(fetchnewclosedtripsbydate())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
            <Button
              onClick={() =>
                preventDoubleClick(markpaid())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Update Incentive
            </Button>
          </div>
          <div align="center">
          {datalistdisplay8b.length>1?(<div>
                   <CSVLink data={datalistdisplay8b} headers={headers8}>Download CSV</CSVLink>
                   </div>
                ):("")}
          </div>
          <Collapse in={expanded7} timeout="auto" unmountOnExit>
          {working?(
          <Loading message={`Loading data...`} />
         ):(<div>
          {datalistdisplay8b.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay8b}
                columns={columns7}
                onCellDoubleClick={(getValue) =>
                  gridcellclick(getValue.row.trip_id)
                }
                autoPageSize
             
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </div>)}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      TCS Return
                    </Typography>
                    <Button
                      expand={expanded8}
                      onClick={()=>setexpanded8(!expanded8)}
                      aria-expanded={expanded8}
                      aria-label="show more"
                    >
                      {expanded8?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            <TextField
              variant="outlined"
              type="date"
              label="Start Date On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData5({ ...searchData5, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start Date On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData5({ ...searchData5, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbystartdate2())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
            <Button
              onClick={() =>
                preventDoubleClick(gettcsquery())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              TCS Query
            </Button>
          </div>
          <div align="center">
          {datalistdisplay16.length>1?(<div>
                   <CSVLink data={datalistdisplay16} headers={headers16}>Download CSV</CSVLink>
                   </div>
                ):("")}
          </div>
          <Collapse in={expanded8} timeout="auto" unmountOnExit>
         {working?(
          <Loading message={`Loading data...`} />
         ):(<div>
          {datalistdisplay16.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay16}
                columns={columns16}
                onCellDoubleClick={(getValue) =>
                  gridcellclick(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </div>)}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
         <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Profit wise breakup (avg. time to book:{finallist.length>0?(totalttc/finallist.length).toFixed(1):""})
                    </Typography>
                    <Button
                      expand={expanded9}
                      onClick={()=>setexpanded9(!expanded9)}
                      aria-expanded={expanded9}
                      aria-label="show more"
                    >
                      {expanded9?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
          <Collapse in={expanded9} timeout="auto" unmountOnExit>
          {datalistdisplay17.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay17}
                columns={columns4b}
               
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
        </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
         <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Back to Sales Record
                    </Typography>
                    <Button
                      expand={expanded19}
                      onClick={()=>setexpanded19(!expanded19)}
                      aria-expanded={expanded19}
                      aria-label="show more"
                    >
                      {expanded19?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
                    <div align="center">
                    <TextField
              variant="outlined"
              type="date"
              label="Start Date On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData15({ ...searchData15, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start Date On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData15({ ...searchData15, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbystartdate4())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
            </div>
          <Collapse in={expanded19} timeout="auto" unmountOnExit>
          {datalistdisplay1.length>1?(<div>
                   <CSVLink data={datalistdisplay1} headers={headers19}>Download CSV</CSVLink>
                   </div>
                ):("")}
          {datalistdisplay1.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay1}
                columns={columns19}
               
                autoPageSize
                onCellDoubleClick={(getValue) =>
                gridcellclickpayment(getValue.row.trip_id)
                    }
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
        </Collapse>
        </Paper>
        </div>
        ):("")}
        
        {role=="Admin" || role=="Accounts"?(
        <Paper variant="outlined" className={classes.paper}>
        <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                     PAN Data
                    </Typography>
                    <Button
                      expand={expanded10}
                      onClick={()=>setexpanded10(!expanded10)}
                      aria-expanded={expanded10}
                      aria-label="show more"
                    >
                      {expanded10?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            <TextField
              variant="outlined"
              type="date"
              label="Start On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData8({ ...searchData8, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData8({ ...searchData8, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(fetchTripsbystartdate())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <div align="center">
          {datalistdisplay11.length>1?(<div>
                   <CSVLink data={datalistdisplay11} headers={headers11}>Download CSV</CSVLink>
                   </div>
                ):("")}
          </div>
             <Collapse in={expanded10} timeout="auto" unmountOnExit>
          {datalistdisplay11.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay11}
                columns={columns11}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        ):("")}

         {role=="Admin" || role=="Accounts"?(
        <Paper variant="outlined" className={classes.paper}>
        <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                     7 Day Data
                    </Typography>
                    <Button
                      expand={expanded12}
                      onClick={()=>setexpanded12(!expanded12)}
                      aria-expanded={expanded12}
                      aria-label="show more"
                    >
                      {expanded12?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            <TextField
              variant="outlined"
              type="date"
              label="Start On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData10({ ...searchData10, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData10({ ...searchData10, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(fetchTripsbystartdate2())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          
         <Collapse in={expanded12} timeout="auto" unmountOnExit>
          {datalistdisplay12.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay12}
                columns={columns14}
                
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        ):("")}
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Special Case Calculation
                    </Typography>
                    <Button
                      expand={expanded11}
                      onClick={()=>setexpanded11(!expanded11)}
                      aria-expanded={expanded11}
                      aria-label="show more"
                    >
                      {expanded11?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                     <FormControl
                                        style={{
                                          minWidth: 240,
                                          marginTop: 16,
                                          marginRight: 32,
                                          marginLeft: 8,
                                        }}
                                      >
                                        <InputLabel id="Account">Account</InputLabel>
                                        <Select
                                          displayEmpty
                                         
                                          classname={classes.textField}
                                          labelId="Account"
                                          
                                          value={filterData.account}
                                          onChange={(e) =>
                                            setfilterData({account:e.target.value})
                                          }
                                        >
                                          <MenuItem value={""}>Clear</MenuItem>
                                          <MenuItem value={"Kotak"}>Kotak</MenuItem>
                                          <MenuItem value={"IndusInd"}>IndusInd</MenuItem>
                                          <MenuItem value={"Axis"}>Axis</MenuItem>
                                          <MenuItem value={"AU Bank"}>AU Bank</MenuItem>
                                          <MenuItem value={"Yes"}>Yes</MenuItem>
                                          <MenuItem value={"HDFC"}>HDFC</MenuItem>
                                          <MenuItem value={"SC-Hitesh"}>SC-Hitesh</MenuItem>
                                          <MenuItem value={"SC-NitinK"}>SC-NitinK</MenuItem>
                                          <MenuItem value={"SC-HarshB"}>SC-HarshB</MenuItem>
                                          <MenuItem value={"SC-Yadvinder"}>SC-Yadvinder</MenuItem>
                                          <MenuItem value={"SC-Qausain"}>SC-Qausain</MenuItem>
                                          <MenuItem value={"SC-Rana"}>SC-Rana</MenuItem>
                                          <MenuItem value={"SC-Sidharth"}>SC-Sidharth</MenuItem>
                                          <MenuItem value={"SC-Abhishek"}>SC-Abhishek</MenuItem>
                                          <MenuItem value={"SC-Amit"}>SC-Amit</MenuItem>
                                          <MenuItem value={"SC-RohitS"}>SC-RohitS</MenuItem>
                                          <MenuItem value={"SC-Pawan"}>SC-Pawan</MenuItem>
                                          <MenuItem value={"SC-Debayan"}>SC-Debayan</MenuItem>
                                          <MenuItem value={"Cash"}>Cash</MenuItem>
                                          <MenuItem value={"Others"}>Others</MenuItem>
                                        </Select>
                                      </FormControl>
                    </FormGroup>
            {/* <Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" label="Final Installment Only"/> */}
            <TextField
              variant="outlined"
              type="date"
              label="Received On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Received On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData6({ ...searchData6, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbyreceived(searchData6.start_date, searchData6.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
             <Button
              onClick={() =>
                preventDoubleClick(getTripsbyaccount(filterData.account))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search by Account
            </Button>
          </div>
          <Collapse in={expanded11} timeout="auto" unmountOnExit>
          {datalistdisplay18.length>0?(<div>
                   <CSVLink data={datalistdisplay18} headers={headers2b}>Download CSV</CSVLink>
                   </div>
                ):("")}
                
          {datalistdisplay18.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay18}
                onCellDoubleClick={(getValue) =>
                  gridcellclickpayment(getValue.row.trip_id)
                }
                columns={columns2b}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      OG Count
                    </Typography>
                    <Button
                      expand={expanded21}
                      onClick={()=>setexpanded21(!expanded21)}
                      aria-expanded={expanded21}
                      aria-label="show more"
                    >
                      {expanded21?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            {/* <Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" label="Final Installment Only"/> */}
            <TextField
              variant="outlined"
              type="date"
              label="Start On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData16({ ...searchData16, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData16({ ...searchData16, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbystartdate3())
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded21} timeout="auto" unmountOnExit>
     
                
          {datalistdisplay19.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay19}
               
                columns={columns2c}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <div align="center">
          <FormGroup row className={classes.formgroup}>
               
                    <Typography variant="h4" align="center" className={classes.headertext}>
                      {" "}
                      Tour Date Wise
                    </Typography>
                    <Button
                      expand={expanded22}
                      onClick={()=>setexpanded22(!expanded22)}
                      aria-expanded={expanded22}
                      aria-label="show more"
                    >
                      {expanded22?<ExpandLessIcon />:<ExpandMoreIcon />}
                    </Button>
                    
                    </FormGroup>
            {/* <Switch  onChange={()=>{setfinalinstallmentflag(!finalinstallmentflag)}} color="secondary" label="Final Installment Only"/> */}
            <TextField
              variant="outlined"
              type="date"
              label="Start On or after"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData17({ ...searchData17, start_date: e.target.value })
              }
            />
            <TextField
              variant="outlined"
              type="date"
              label="Start On or before"
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
              onChange={(e) =>
                setsearchData17({ ...searchData17, end_date: e.target.value })
              }
            />
            <Button
              onClick={() =>
                preventDoubleClick(getTripsbystartdate5(searchData17.start_date, searchData17.end_date))
              }
              color="secondary"
              variant="contained"
              className={classes.button}
            >
              Search
            </Button>
          </div>
          <Collapse in={expanded22} timeout="auto" unmountOnExit>
     
                
          {datalistdisplay20.length > 0 ? (
            <div style={{ height: 800, width: "100%" }}>
              <DataGrid
                rows={datalistdisplay20}
               
                columns={columns17}
                autoPageSize
                // pageSize={12}
                // autoHeight
              ></DataGrid>
            </div>
          ) : (
            <div align="center">
              <h1>No data found</h1>
            </div>
          )}
          </Collapse>
        </Paper>
      </TabPanel>
      <TabPanel value={value} index={9}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                 preventDoubleClick( getTripsbyTL2(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl2}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay16.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay16}
                    columns={columns4}
                    
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={3}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  preventDoubleClick(getTripsbyTL3(searchData.start_date, searchData.end_date))
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl3}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={4}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  getTripsbyTL4(searchData.start_date, searchData.end_date)
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl4}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={5}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  getTripsbyTL5(searchData.start_date, searchData.end_date)
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl5}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={6}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  getTripsbyTL6(searchData.start_date, searchData.end_date)
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl6}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={7}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  getTripsbyTL7(searchData.start_date, searchData.end_date)
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl7}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
      <TabPanel value={value} index={8}>
      {cuser && role && tl && emp ? (
          <Paper variant="outlined" className={classes.paper}>
            <Typography
              variant="h4"
              align="center"
              className={classes.headertext}
            >
              {" "}
              Sales
            </Typography>
            <Typography
              variant="h6"
              align="center"
              className={classes.headertext}
            >
              
            </Typography>
            <div align="center">
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or after"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, start_date: e.target.value })
                }
              />
              <TextField
                variant="outlined"
                type="date"
                label="Converted On or before"
                className={classes.textField}
                InputLabelProps={{ shrink: true }}
                onChange={(e) =>
                  setsearchData({ ...searchData, end_date: e.target.value })
                }
              />
              <Button
                onClick={() =>
                  getTripsbyTL8(searchData.start_date, searchData.end_date)
                }
                color="secondary"
                variant="contained"
                className={classes.button}
              >
                Search
              </Button>
              <h2>TL: {tl8}</h2>
              {datalistdisplay.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay}
                    columns={columns}
                    autoPageSize
                    // pageSize={12}
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
              {datalistdisplay2.length > 0 ? (
                <div style={{ height: 800, width: "100%" }}>
                  <DataGrid
                    rows={datalistdisplay2}
                    columns={columns4}
                    // pageSize={10}
                    onCellDoubleClick={(getValue) =>
                      gridcellclickpayment(getValue.row.trip_id)
                    }
                    autoPageSize
                    // autoHeight
                  ></DataGrid>
                </div>
              ) : (
                <div align="center">
                  <h1>No data found</h1>
                </div>
              )}
            </div>
          </Paper>
        ) : (
          "Loading..."
        )}
      </TabPanel>
    </Box>
    </div>):(<div></div>)}
    </div> );
};

export default Dashboard;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
